<template>
  <div class="table-container">
    <div class="table-body" :class="{ 'overIsVisible': pageName == 'UniPromotionNew' }">
      <div class="table-tools flex_wrap mb-10 " v-if="pageName !== 'oceanEngineAdvertiser'">
        <el-button class="mb-10 responsiveButton" v-if="addPermission && url.add" type="primary" size="small"
          icon="el-icon-circle-plus" @click="open_add_dv">
          添加
        </el-button>
        <template v-if="buttons">
          <template v-for="(item, index) in buttons">
            <el-button v-if="permissions.indexOf(item.permission) !== -1 || item.notNeedPermission"
              :key="item.permission + index" :type="item.type" size="small" :icon="item.icon" @click="item.click"
              class="mb-10  responsiveButton">
              {{ item.text }}
            </el-button>
          </template>
        </template>
        <el-button class="mb-10  responsiveButton" v-if="deleteBatchPermission && url.delete_batch" type="danger"
          size="small" icon="el-icon-delete-solid" @click="delete_batch">
          批量删除
        </el-button>
        <div class="flex alcenter  flex_wrap flex_grow_1" v-if="pageName == 'UniPromotion'">
          <div class="smart_bid_type_box flex alcenter mb-10 mr20">
            <div class="flex-center" :class="{ 'activeType': !activeType }" @click="changeActiveType(0)">控成本投放</div>
            <div class="flex-center" :class="{ 'activeType': activeType }" @click="changeActiveType(1)">放量投放</div>
          </div>
          <div class="relative">
            <div class=" filter_box mr20 flex-center mb-10" @click="showFilterPopup = !showFilterPopup">
              <i class="el-icon-s-tools mr10"></i>
              全部筛选

            </div>
            <div class="account_selector_popup_box account_selector_popup_box3" v-if="showFilterPopup">
              <div class=" flex-between  flex_wrap alcenter">
                <div>
                  <div class="font-bold pb10">
                    计划创建时间
                  </div>
                  <el-date-picker popper-class="datePicker2" @change="pickData($event, true)" v-model="selectData"
                    type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
                    end-placeholder="结束日期" :picker-options="pickerOptions" format="yyyy 年 MM 月 dd 日">
                  </el-date-picker>
                </div>
                <div>
                  <div class="font-bold pb10">
                    消耗情况
                  </div>
                  <el-select @change="changeConsumeInfo" class=" mb-10 responsiveInput2" v-model="selectedConsumeStatus"
                    placeholder="计划状态">
                    <el-option v-for="item in consumeOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="confirm_box flex-end alcenter pt20">
                <el-button round @click="showFilterPopup = false">取消</el-button>
                <el-button type="primary" round @click="confirmToChange">确定</el-button>
              </div>
            </div>
          </div>
          <el-select clearable @change="changePageIndexTogetDate" class=" mb-10  responsiveInput3"
            v-model="selectedPlanStatus" placeholder="计划状态">
            <el-option v-for="item in planOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>

          <div class="searchPlanBox flex alcenter ">
            <el-select @change="changeConsumeInfo" class=" mb-10 " v-model="selectedSearchPlanStatus" placeholder="计划">
              <el-option v-for="item in searchPlanOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-input v-model="searchPlanKeyWord" @clear="searchPlanKeyWord = null" clearable
              :placeholder="'请输入' + searcPlaceholder + '名称/ID'" size="medium" class="responsiveInput3  mb-10" />
            <div class="search_icon_box flex-center" @click="changePageIndexTogetDate">
              <i class="el-icon-search"></i>
            </div>
          </div>
        </div>
        <span v-for="(search, index) in searchs" :key="index" class="mb-10">
          <el-input v-if="search.type === 'input'" v-model="query[search.name]" clearable
            :placeholder="search.placeholder" size="medium" class="responsiveInput mr10 "
            :class="search.width ? 'responsiveInput2' : ''" />
          <el-date-picker v-else-if="search.type === 'dateTime'" v-model="query[search.name]"
            :placeholder="search.placeholder" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" align="right"
            size="medium" class="mr10 responsiveInput2 " />
          <el-select v-else-if="search.type === 'select' || search.type === 'select2'" filterable
            :remote="isRemoteSearchField(search)"
            :remote-method="search.remoteMethod"
            :loading="getRemoteSearchLoading(search)"
            :popper-class="getRemoteSearchPopperClass(search, index)"
            v-model="query[search.name]" clearable :placeholder="search.placeholder" size="medium"
            class="mr10 responsiveInput " @change="selectChange($event, search.select2)"
            @visible-change="handleRemoteSearchVisible(search, index, $event)">
            <el-option v-for="(option, index) in search.selectValue" :key="option + index" :label="option.value"
              :value="option.key" />
          </el-select>
          <el-date-picker class="h30 mr10" v-else-if="search.type === 'startWithEndDateTime'" popper-class="datePicker2"
            @change="pickData" v-model="selectData" type="daterange" align="right" unlink-panels range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" format="yyyy 年 MM 月 dd 日">
          </el-date-picker>
          <div @click="goShowSelectAccountPopup(search.selectValue)"
            class="flex-between cp fs12 alcenter selectAccountBox mr10" v-else-if="search.type === 'selectAccount'">
            <div>
              <i class="el-icon-user-solid "></i>
              {{ search.selectValue && search.selectValue[0] && search.selectValue[0].value }}
            </div>
            <div>
              <span class="c_primary pr10" v-if="search.selectValue && search.selectValue.length">等{{
                search.selectValue.length
                || 0 }}个账户</span>
              <i class="el-icon-arrow-down"></i>
            </div>
          </div>
        </span>

        <el-button class="mb-10 responsiveButton" v-if="searchs && searchs.length > 0" type="primary" size="small"
          icon="el-icon-search" @click="handleSearch">搜索
        </el-button>

        <el-button class="mb-10 responsiveButton"
          v-if="pageName == 'ShutDownDueToOverallLosses' || pageName == 'intelligentRegulation' || pageName == 'budgetRegulation' || pageName == 'BalanceManage' || pageName == 'BudgetManage' || pageName == 'contacts' || pageName == 'intelligentAutoRebuildManage'"
          type="primary" size="small" icon="el-icon-circle-plus
" @click="handleAdd">新增
        </el-button>
      </div>

      <div class="advertiser-tools-container mb-10" v-else>
        <!-- 操作按钮栏 (新增/删除/授权/同步等) -->
        <div class="advertiser-tools__actions-bar">
          <div class="left-actions">
            <el-button class="responsiveButton" v-if="addPermission && url.add" type="primary" size="small"
              icon="el-icon-circle-plus" @click="open_add_dv">
              添加
            </el-button>
            <template v-if="buttons">
              <template v-for="(item, index) in buttons">
                <el-button v-if="permissions.indexOf(item.permission) !== -1 || item.notNeedPermission"
                  :key="item.permission + index" :type="item.type" size="small" :icon="item.icon" @click="item.click"
                  class="responsiveButton">
                  {{ item.text }}
                </el-button>
              </template>
            </template>
            <el-button class="responsiveButton" v-if="deleteBatchPermission && url.delete_batch" type="danger"
              size="small" icon="el-icon-delete-solid" @click="delete_batch">
              批量删除
            </el-button>
          </div>
          <div class="right-actions">
            <el-button type="primary" plain round size="small" @click="resetSearchConditions">重置</el-button>
            <div class="line"></div>
            <el-button type="primary" round size="small" @click="addAccountAuthorize">+账户授权</el-button>
            <el-button type="primary" round size="small" @click="updateAccountInfo">更新账户信息</el-button>
            <el-button v-if="isAdmin" type="danger" plain round size="small" @click="handleManualRefreshAll">手动同步全部授权</el-button>
            <el-button type="primary" round size="small">闲置账户检测</el-button>
          </div>
        </div>

        <!-- 筛选过滤条件栏 -->
        <div class="advertiser-tools__filters-bar">
          <div class="filters-grid">
            <span v-for="(search, index) in searchs" :key="index" class="filter-item">
              <el-input v-if="search.type === 'input'" v-model="query[search.name]" clearable
                :placeholder="search.placeholder" size="medium" class="responsiveInput"
                @keyup.enter.native="handleSearch"
                :class="search.width ? 'responsiveInput2' : ''" />
              <el-date-picker v-else-if="search.type === 'dateTime'" v-model="query[search.name]"
                :placeholder="search.placeholder" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" align="right"
                size="medium" class="responsiveInput2" />
              <el-select v-else-if="search.type === 'select' || search.type === 'select2'" filterable
                :remote="isRemoteSearchField(search)"
                :remote-method="search.remoteMethod"
                :loading="getRemoteSearchLoading(search)"
                :popper-class="getRemoteSearchPopperClass(search, index)"
                v-model="query[search.name]" clearable :placeholder="search.placeholder" size="medium"
                class="responsiveInput" @change="selectChange($event, search.select2)"
                @visible-change="handleRemoteSearchVisible(search, index, $event)">
                <el-option v-for="(option, index) in search.selectValue" :key="option + index" :label="option.value"
                  :value="option.key" />
              </el-select>
              <el-date-picker class="h30" v-else-if="search.type === 'startWithEndDateTime'" popper-class="datePicker2"
                @change="pickData" v-model="selectData" type="daterange" align="right" unlink-panels range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" format="yyyy 年 MM 月 dd 日">
              </el-date-picker>
            </span>
          </div>
          <div v-if="searchs && searchs.length > 0" class="filters-actions">
            <el-button class="responsiveButton search-btn" type="primary" size="small"
              icon="el-icon-search" @click="handleSearch">搜索
            </el-button>
          </div>
        </div>
      </div>

      <div v-if="hideTable" v-loading="loading2" class="common-table-slot-content">
        <slot name="content" :rows="tableData" :loading="loading2" :page="page" :query="query"
          :selected-ids="selectedIds"></slot>
      </div>
      <el-table v-else v-loading="loading2" border :data="tableData" row-key="id" :empty-text="isNoData ? '请重试' : '暂无数据'"
        :height="loadingMore || limitHeight ? '68vh' : null" style="width: 100%;" ref="multipleTable"
        @sort-change="handleSortChange" @selection-change="handleSelectionChange"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
        <el-table-column v-if="deleteBatchPermission && url.delete_batch" type="selection" :selectable="isRowSelectable" width="40"
          align="center"></el-table-column>
        <!--<el-table-column type="index" :index="1" label="序号" width="75" align="center"></el-table-column>-->

        <!--展开详情-->
        <el-table-column v-if="tableDetailColumns.length > 0" type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="table-expand">
              <el-form-item v-for="(col, index) in tableDetailColumns" :label="col.label + '：'" :key="index">
                <span>{{ props.row[col.field] }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>

        <template v-for="(item, index) in tableColumns">
          <template v-if="item.show">
            <el-table-column class-name="image-column" v-if="item.img" :key="index" :prop="item.field"
              :label="item.label" :width="item.width" align="center">
              <template slot-scope="scope">
                <template v-if="scope.row[item.field]">
                  <el-image v-if="item.qrCode" style="width: 60px; height: 60px" fit="cover"
                    :src="qrCodeUrl + scope.row[item.field]"
                    :preview-src-list="[qrCodeUrl + scope.row[item.field]]"></el-image>
                  <el-image v-else style="max-width: 60px; max-height: 60px"
                    :style="item.avatar ? 'border-radius:50%;' : ''" fit="cover" :src="scope.row[item.field]"
                    :preview-src-list="[scope.row[item.field]]"></el-image>
                </template>
                <el-avatar v-else icon="el-icon-picture"></el-avatar>
              </template>
            </el-table-column>

            <el-table-column v-else-if="item.status" :key="index" :prop="item.field" :label="item.label"
              :width="item.width" align="center">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row[item.field] === 1
                  ? '当前状态: 正常'
                  : '当前状态: 锁定'
                  " placement="bottom">
                  <el-switch v-model="scope.row[item.field]" active-color="#13ce66" inactive-color="#ff4949"
                    :disabled="isRowReadOnly(scope.row)"
                    :active-value="1" :inactive-value="0" @change="statusChange(scope.row, item, index)">
                  </el-switch>
                </el-tooltip>
              </template>
            </el-table-column>

            <!--状态-->
            <el-table-column v-else-if="item.show.type === 'status'" :key="index" :prop="item.field" :label="item.label"
              :width="item.width" align="center">
              <template slot-scope="scope">
                <template v-for="(it, ind) in item.values">
                  <template v-if="scope.row[item.field] === it.key">
                    <el-dropdown :key="ind">
                      <el-tag :class="{ cp: havePermission(item.permission) }" :type="it.type" effect="dark">
                        {{ it.value }}
                      </el-tag>
                      <el-dropdown-menu v-if="havePermission(item.permission)" slot="dropdown" class="status-menu">
                        <template v-for="(it, ind) in item.values">
                          <template v-if="scope.row[item.field] !== it.key">
                            <div :key="ind" @click="moreStatusChange(scope.row, item, it)">
                              <el-dropdown-item>{{
                                it.value
                              }}
                              </el-dropdown-item>
                            </div>
                          </template>
                        </template>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                </template>
              </template>
            </el-table-column>

            <el-table-column v-else-if="item.show.type == 'select'" :key="index" :prop="item.field" :label="item.label"
              :width="item.width" align="center">
              <template slot-scope="scope">
                <span>{{
                  item.selectData.find((i) => {
                    if (i.id === scope.row[item.field]) {
                      return i.name
                    }
                  })
                    ? item.selectData.find((i) => {
                      if (i.id == scope.row[item.field]) {
                        return i.name
                      }
                    }).name
                    : ''
                }}</span>
              </template>
            </el-table-column>

            <el-table-column v-else-if="item.show.type == 'tag'" :key="index" :prop="item.field" :label="item.label"
              :width="item.width" align="center">
              <template slot-scope="scope">
                <template v-for="(tag, ind) in item.show.tags">
                  <el-tag v-if="scope.row[item.field] == tag.key" :class="{ 'willPublic': tag.value == '预发布' }"
                    :key="ind" :type="tag.type" effect="dark">
                    {{ tag.value }}
                  </el-tag>
                  <span v-else :key="ind"></span>
                </template>
              </template>
            </el-table-column>

            <!--金额-->
            <el-table-column v-else-if="item.show.type == 'money'" :key="index" :prop="item.field" :label="item.label"
              :width="item.width" align="center">
              <template slot-scope="scope">
                {{ scope.row[item.field] ? scope.row[item.field] / 100 : 0 }}
              </template>
            </el-table-column>

            <!--百分比-->
            <el-table-column v-else-if="item.show.type == 'hundredthsRatio'" :key="index" :prop="item.field"
              :label="item.label" :width="item.width" align="center">
              <template slot-scope="scope">
                {{ scope.row[item.field] ? scope.row[item.field] + '%' : 0 }}
              </template>
            </el-table-column>

            <!-- 原始占比 (0.2 -> 20%) -->
            <el-table-column v-else-if="item.show.type == 'ratio'" :key="index" :prop="item.field" :label="item.label"
              :width="item.width" align="center">
              <template slot-scope="scope">
                {{ scope.row[item.field] ? (scope.row[item.field] * 100).toFixed(0) + '%' : '0%' }}
              </template>
            </el-table-column>

            <!-- 时间格式化 -->
            <el-table-column v-else-if="item.show.type == 'datetime'" :key="index" :prop="item.field" :label="item.label"
              :width="item.width" align="center">
              <template slot-scope="scope">
                {{ formatTime(scope.row[item.field]) }}
              </template>
            </el-table-column>

            <!--万分比-->
            <el-table-column v-else-if="item.show.type == 'thousandthsRatio'" :key="index" :prop="item.field"
              :label="item.label" :width="item.width" align="center">
              <template slot-scope="scope">
                {{
                  scope.row[item.field] ? scope.row[item.field] / 100 + '%' : 0
                }}
              </template>
            </el-table-column>

            <!--链接-->
            <el-table-column v-else-if="item.show.type == 'link'" :key="index" :prop="item.field" :label="item.label"
              :width="item.width" align="center">
              <template slot-scope="scope">
                <a :href="scope.row[item.field]" target="_blank">{{
                  scope.row[item.field]
                }}</a>
              </template>
            </el-table-column>
            <!--监控方式 -->
            <el-table-column v-else-if="item.show.type == 'advertiserAlert'" :key="index" :prop="item.field"
              :label="item.label" :width="item.width" align="center">
              <template slot-scope="scope">
                <div class="table-alert-inline">
                  <el-tag v-if="scope.row.alertConfigured" size="mini" type="success" effect="plain">
                    {{ scope.row.alertThresholdText || '已设置' }}
                  </el-tag>
                  <el-tag v-else size="mini" type="warning" effect="plain">未设置</el-tag>
                  <el-button type="text" size="mini" icon="el-icon-bell"
                    @click.stop="$emit('advertiser-alert-edit', scope.row)">
                    {{ scope.row.alertConfigured ? '改' : '设置' }}
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column v-else-if="item.tableType === 'monitorMode'" :key="index" :prop="item.field"
              :label="item.label" :width="item.width" align="center">
              <template slot-scope="scope">
                <div>
                  监控{{ scope.row.monitorObject && scope.row.monitorObject.length }}个{{ scope.row.monitorType == 1 ?
                    '账户' :
                    scope.row.monitorType
                      == 2 ? '计划' : scope.row.monitorType == 3 ? '抖音号' : '商品' }}
                </div>
                <div class="c_ffb563 fs14">
                  限制：推商品
                </div>
              </template>
            </el-table-column>

            <!--监控对象 -->
            <el-table-column v-else-if="item.tableType === 'monitorList'" :key="index" :prop="item.field"
              :label="item.label" :width="item.width" align="center">
              <template slot-scope="scope">
                <div class="monitorListBox">
                  <div class="" v-for="(obj, index2) in scope.row.monitorObject" :key="index2">
                    {{ obj }}
                  </div>
                </div>

              </template>
            </el-table-column>

            <!-- 计划名称 -->
            <el-table-column v-else-if="item.type == 'planName'" :key="index" :prop="item.field" :label="item.label"
              :width="item.width" align="center">
              <template slot-scope="scope">
                <div class="flex alcenter pl30">
                  <el-switch v-model="scope.row.switchStatus"
                    @change="switchChange(scope.row.switchStatus ? 1 : 0, scope.$index, scope.row.adId)">
                  </el-switch>
                  <div class="text-left pl20">
                    <div class="">
                      {{ scope.row.name }}
                    </div>
                    <div class="c_999 fs14">
                      ID: {{ scope.row.adId }}
                    </div>
                  </div>
                </div>

              </template>
            </el-table-column>
            <!-- 计划状态 -->
            <el-table-column v-else-if="item.type == 'planStatus'" :key="index" :prop="item.field" :label="item.label"
              :width="item.width" align="center">
              <template slot-scope="scope">
                <div class="flex-center " :class="{ 'c_ff3939': scope.row.status2 == '已暂停' }">
                  <div class="greenDot" v-if="scope.row.status2 == '投放中'"></div> {{ scope.row.status2 }}
                  <el-tooltip placement="top" effect="dark">
                    <div slot="content">成本保障生效中<br />目前正处于全域推广每日成本保障生效期，系统将根据保障规则，返还当日全域推广超成本部分投放金额</div>
                    <div class="protectActive flex-center ml5"
                      v-if="scope.row.status2 == '投放中' && scope.row.compensateInfo.compensateStatus == 'IN_EFFECT'">

                      <i class="el-icon-s-claim"></i>
                      保

                    </div>
                  </el-tooltip>
                </div>
                <!-- 新增审核建议按钮 -->
                <div v-if="scope.row.status2 === '投放中' && scope.row.hasSuggestion" class="mt5 text-center">
                    <el-button
                        type="primary"
                        size="mini"
                        plain
                        style="background-color: #e6f7ff; color: #1890ff; padding: 5px 8px; border-radius: 4px;"
                        @click="showSuggestionDialog({ suggestionData: scope.row.suggestionData, productInfo: scope.row.productInfo })">
                        审核建议
                    </el-button>
                </div>
              </template>
            </el-table-column>
            <!-- 推广设置 -->
            <el-table-column v-else-if="item.type == 'promotionSettings'" :key="index" :prop="item.field"
              :label="item.label" :width="item.width" align="center">
              <template slot-scope="scope">
                <div>
                  <div>
                    日预算 <span class="font-bold">{{ scope.row.budget }}</span> 元
                  </div>
                  <div>
                    整体支付ROI <span class="font-bold">{{ scope.row.roi2Goal }}</span>
                  </div>
                </div>
              </template>
            </el-table-column>

            <!-- 操作 -->
            <el-table-column v-else-if="item.type == 'operation'" :key="index" :prop="item.field" :label="item.label"
              :width="item.width" align="center">
              <template slot-scope="scope">
                <div class="c_primary">
                  <div @click="gotoEdit(scope.row)">
                    编辑
                  </div>
                  <div @click="switchChange(2, scope.$index, scope.row.adId)">
                    删除
                  </div>
                </div>
              </template>
            </el-table-column>

            <!-- 抖音号信息 -->
            <el-table-column v-else-if="item.type == 'dyInfo'" :key="index" :prop="item.field" :label="item.label"
              :width="item.width" align="center">
              <template slot-scope="scope">
                <div class="flex-center alcenter">
                  <img class="avtImg"
                    :src="scope.row.roomInfo[0] && scope.row.roomInfo[0].anchorAvatar ? scope.row.roomInfo[0].anchorAvatar : 'https://wx.tujianjian.com/static/aiCompanion/loadFail.png'"
                    alt="">
                  <div class="pl10 text-left">
                    {{ scope.row.roomInfo[0] && scope.row.roomInfo[0].anchorName ? scope.row.roomInfo[0].anchorName :
                      advertiserName }}
                    <div class="c_999 fs14 pt10">
                      ID: {{ scope.row.roomInfo[0] && scope.row.roomInfo[0].anchorId ? scope.row.roomInfo[0].anchorId :
                        advertiserId }}
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>

            <!-- 商品信息 -->
            <el-table-column v-else-if="item.type == 'goodsInfo'" :key="index" :prop="item.field" :label="item.label"
              :width="item.width" align="center">
              <template slot-scope="scope">
                <div class="cp">
                  <el-popover placement="top" :width="isPageSmall ? '300' : '400'" trigger="hover">
                    <div class="scroll_box">
                      <div class="hoverProductBox mb10 flex alcenter" v-for="(item, index) in scope.row.productInfo"
                        :key="index">
                        <img class="pr5" :src="item.productImage" alt="">
                        <div>
                          <div class="overflow1_300">
                            {{ item.productName }}
                          </div>
                          <div class="c_999 fs14">
                            ID:{{ item.productId }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div slot="reference" class="flex alcenter" v-if="scope.row.productInfo.length > 1">
                      <div class="goods_box flex-center">
                        <img class="pr5" :src="scope.row.productInfo[0].productImage" alt="">
                        <img :src="scope.row.productInfo[1].productImage" alt="">
                        <img v-if="scope.row.productInfo[2]" :src="scope.row.productInfo[2].productImage" alt="">
                        <img class="pl5" v-if="scope.row.productInfo[3]" :src="scope.row.productInfo[3].productImage"
                          alt="">
                      </div>
                      <div class="pl10 text-left">
                        共{{ scope.row.productInfo.length }}个商品
                      </div>
                    </div>
                    <div slot="reference" class="flex alcenter" v-if="scope.row.productInfo.length == 1">
                      <img class="avtImg" :src="scope.row.productInfo[0].productImage" alt="">
                      <div class="pl10 text-left overflow1">
                        {{ scope.row.productInfo[0].productName }}
                        <div class="c_999 fs14 pt10 overflow1">
                          ID: {{ scope.row.productInfo[0].productId }}
                        </div>
                      </div>
                    </div>
                  </el-popover>

                </div>
              </template>
            </el-table-column>
            <!--账户-->
            <el-table-column v-else-if="item.account" :key="index" :prop="item.field" :label="item.label"
              :width="isPageSmall ? '280px' : item.width" align="center">
              <template slot-scope="scope">
                <div class="po_r">
                  <div>
                    <div v-if="scope.row.account" class="account_box"
                      :class="{ 'account_box4': route_params.advertiserName }" @click.stop="showSelectPopup(scope.$index, 0
                      )">
                      <div class="account_left_box">
                        <div class="accountNameBox">
                          <i class="el-icon-user-solid "></i>
                          <span class="name overflow1">{{ scope.row.account.name }}</span>
                        </div>
                        <div class="idBox">
                          ID:{{ scope.row.account.id }}
                        </div>
                      </div>
                      <div class="account_shop_box">店铺</div>
                      <div class="account_right_box">
                        <i class=" el-icon-arrow-down"></i>
                      </div>
                    </div>
                    <div v-else class="account_box account_box3" @click.stop="showSelectPopup(scope.$index, 0
                    )">
                      <div>
                        <i class="el-icon-user-solid "></i>
                        <span class="pl5 ">请选择账户</span>
                      </div>
                      <i class=" el-icon-arrow-down"></i>
                    </div>
                  </div>
                  <div class="account_selector_popup_box" :class="{ 'noSelect': !scope.row.account }"
                    v-if="showPopup == scope.$index">
                    <el-input @input="searchAccountInput" v-model="searchAccount" class="input250"
                      placeholder="请输入广告账户名称/ID搜索" prefix-icon="el-icon-search">
                    </el-input>
                    <div class="select_account_all_box" @scroll="handleAccountListScroll($event)">
                      <div class=" account_box2 mb10" @click="goSelectAccount(scope.$index, item)"
                        v-for="(item, index2) in searchAccount ? searchAccountList : accountList" :key="index2">
                        <div class="account_left_box">
                          <div class="accountNameBox">
                            <span class="name overflow1">{{ item.name }}</span>
                          </div>
                          <div class="idBox">
                            ID:{{ item.advertiserId }}
                          </div>
                        </div>
                        <div class="account_right_box2 ">
                          <div class="account_shop_box2 mb10">店铺</div>
                          <div class="account_normal_box">授权正常</div>
                        </div>
                      </div>
                      <div v-if="!accountList.length || (searchAccount && !searchAccountList.length)">
                        暂无数据
                      </div>
                      <div class="text-center c_999 pt10"
                        v-else-if="searchAccount ? searchAccountScrollLoading : accountScrollLoading">
                        加载更多中...
                      </div>
                      <div class="text-center c_999 pt10"
                        v-else-if="!(searchAccount ? searchAccountScrollHasMore : accountScrollHasMore)">
                        已加载全部
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <!--抖音号-->
            <el-table-column show-overflow-tooltip v-else-if="item.dyNumber" :key="index" :prop="item.field"
              :label="item.label" :width="isPageSmall ? '280px' : item.width" align="center">
              <template slot-scope="scope">
                <div class="po_r">
                  <div>
                    <div class="account_box" :class="{ 'account_box4': route_params.advertiserName }"
                      v-if="scope.row.selectedDYNumber" @click.stop="showSelectPopup(scope.$index, 1, scope.row.account
                      )">
                      <div class="account_left_box">
                        <div class="accountNameBox">
                          <!-- <img src="../../static/3709051083201577205.jpg" alt=""> -->
                          <i class="el-icon-user-solid "></i>
                          <span class="name overflow1">{{ scope.row.selectedDYNumber.name }}</span>
                        </div>
                        <div class="idBox">
                          <div class="account_shop_box2 mr5" v-if="scope.row.selectedDYNumber.permissions">官方</div>
                          ID:{{ scope.row.selectedDYNumber.id }}
                        </div>
                      </div>

                      <div class="account_right_box">
                        <i class=" el-icon-arrow-down"></i>
                      </div>
                    </div>
                    <div v-else class="account_box account_box3" :class="{ 'account_box4': !scope.row.account }"
                      @click.stop="showSelectPopup(scope.$index, 1, scope.row.account
                      )">
                      <!-- <div> -->
                      <!-- <i class="el-icon-user-solid "></i> -->
                      <span class="pl5 ">请选择抖音号</span>
                      <!-- </div> -->
                      <i class=" el-icon-arrow-down"></i>
                    </div>
                  </div>
                  <div class="account_selector_popup_box" v-if="showNumberPopup == scope.$index">
                    <div class="number_top flex alcenter">
                      <el-input v-model="searchDYNumber" @input="inputSearchDYNumber(scope.$index)" class="input250"
                        placeholder="请输入广告账户名称/ID搜索" prefix-icon="el-icon-search">
                      </el-input>
                      <!-- <div class="choose_box flex alcenter">
                        <div @click="choosed_box = 0" :class="{ 'choosed_box': !choosed_box }">单选</div>
                        <div @click="choosed_box = 1" :class="{ 'choosed_box': choosed_box }">多选</div>
                      </div> -->
                    </div>
                    <div class="select_account_all_box">
                      <div class="select_account_box account_box2 mb10" @click="goSelectDYNumber(index2, scope.$index)"
                        v-for="(item, index2) in searchDYNumber ? searchDYNumberList : scope.row.dyNumberList"
                        :key="index2">
                        <el-radio ref="radio" size="medium" v-model="selectedDYNumber" :label="index2" class="no-label">
                        </el-radio>
                        <div class="account_left_box">
                          <div class="accountNameBox">
                            <i class="el-icon-user-solid "></i>
                            <!-- <img src="../../static/3709051083201577205.jpg" alt=""> -->
                            <span class="name">{{ item.name }}</span>
                          </div>
                          <div class="idBox">
                            <div class="account_shop_box2 mr5" v-if="item.permissions">官方</div>
                            ID:{{ item.id }}
                          </div>
                        </div>
                        <!-- <div class="account_right_box2 ">
                          <div class="account_shop_box2 mb10">店铺</div>
                          <div class="account_normal_box">授权正常</div>
                        </div> -->
                      </div>
                      <div class="text-center" v-if="!scope.row.dyNumberList.length">
                        暂无数据
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- 商品组 -->
            <el-table-column v-else-if="item.productGroup" :key="index" :prop="item.field" :label="item.label"
              :width="item.width || '520px'" align="center">
              <template slot-scope="scope">
                <div>
                  <div v-if="scope.row.selectedList && scope.row.selectedList.length"
                    class="add_product_box2 flex-between alcenter pr20">
                    <div class="flex alcenter">
                      <img :src="scope.row.selectedList[0].img || scope.row.selectedList[0].productImage" alt="">
                      <div class="pl10 product_text_box">
                        <div class="overflow1">
                          {{ scope.row.selectedList[0].productName }}
                        </div>
                        <div class="fs14 c_999 overflow1">
                          ID: {{ scope.row.selectedList[0].productId }}
                        </div>
                      </div>
                    </div>
                    <div class="uni-promotion-product-summary">
                      <div>共{{ scope.row.selectedList.length }}个商品</div>
                      <div class="fs12 c_999 pt5">
                        {{ getUniPromotionMaterialLabel(scope.row) }} /
                        已配素材 {{ getSelectedCreativeCount(scope.row) }}/{{ scope.row.selectedList.length }}
                      </div>
                    </div>
                  </div>
                  <div class="add_product_box" v-else
                    :class="{ 'account_box4': !scope.row.account || (scope.row.dyNumberList ? scope.row.dyNumberList.length ? !scope.row.selectedDYNumber : false : true) }"
                    @click="selectProduct(scope, scope.$index, 1)">
                    <i class="el-icon-circle-plus"></i>
                    点击添加商品
                  </div>
                </div>

              </template>
            </el-table-column>
            <el-table-column v-else-if="item.promotionAction" :key="index" :prop="item.field" :label="item.label"
              :width="item.width || '130px'" align="center">
              <template slot-scope="scope">
                <div class="uni-promotion-actions-column" v-if="scope.row.selectedList && scope.row.selectedList.length">
                  <div class="c_346bf6" @click="openPromotionConfig(scope, scope.$index)">
                    商品配置投放
                  </div>
                </div>
                <div class="c_999" v-else>--</div>
              </template>
            </el-table-column>
            <el-table-column v-else-if="item.editProductAction" :key="index" :prop="item.field" :label="item.label"
              :width="item.width || '110px'" align="center">
              <template slot-scope="scope">
                <div class="uni-promotion-actions-column" v-if="scope.row.selectedList && scope.row.selectedList.length">
                  <div class="c_346bf6" @click="selectProduct(scope, scope.$index, 0)">
                    编辑商品
                  </div>
                </div>
                <div class="c_999" v-else>--</div>
              </template>
            </el-table-column>
            <!-- 整体ROI目标/日预算 -->
            <el-table-column v-else-if="item.target" :key="index" :prop="item.field" :label="item.label"
              :width="item.width" align="center">
              <template slot="header">
                <div class="relative">
                  整体ROI目标/日预算
                  <div class="c_346bf6" @click="showSelectPopup(false, 3)">批量设置 </div>
                </div>
              </template>
              <template slot-scope="scope">
                <div class="target_box">
                  <div>
                    <div class="" v-if="scope.row.AllBudget">
                      {{ scope.row.AllBudget.roiTarget }} / {{ scope.row.AllBudget.dayBudget }}元
                      <i @click="showSelectPopup(scope.$index, 2, true
                      )" class="el-icon-edit"></i>
                      <div v-if="pageName == 'UniPromotionNew'" class="fs12 c_999 pt5">
                        {{ scope.row.deliveryMode == 'COST' || !scope.row.deliveryMode ? '控成本投放' : scope.row.deliveryMode }}
                      </div>
                    </div>
                    <div class="add_target_box" v-else>
                      未设置
                      <i @click="showSelectPopup(scope.$index, 2
                      )" class="el-icon-edit"></i>
                    </div>
                  </div>
                  <div class="account_selector_popup_box" v-if="showTargetPopup == scope.$index">
                    <div class="text-left">
                      整体ROI目标
                    </div>
                    <div>
                      <el-input type="number" @blur="inputBlur(0)" @input="inputRoiTarget"
                        :class="{ 'no-input': noRoiTarget }" class="responsiveInput4" v-model="roiTarget"
                        placeholder="请输入整体ROI目标 "></el-input>
                    </div>
                    <div v-if="noRoiTarget" class="c_ff3939 text-left">
                      {{ roiTarget ? '整体ROI目标必须在0.01-10000之间' : '请输入整体ROI目标' }}
                    </div>
                    <div class="text-left pt10">
                      日预算
                    </div>
                    <div class="relative pt5">
                      <el-input type="number" @blur="inputBlur(1)" @input="inputBudget"
                        :class="{ 'no-input': nodayBudget }" suffix-icon="元" v-model="dayBudget" placeholder="请输入日预算"
                        class="responsiveInput4"></el-input>
                      <div class="yuan_box">
                        元
                      </div>
                    </div>

                    <div v-if="nodayBudget" class="c_ff3939 text-left">
                      {{ dayBudget ? '日预算必须在300-999999999.99之间' : '请输入整体日预算' }}
                    </div>
                    <div class="flex-end pt20">
                      <el-button size="small" round @click.stop="showTargetPopup = null">取消</el-button>
                      <el-button type="primary" size="small" round
                        @click="confirmBudget(scope.$index, 1)">确定</el-button>
                    </div>
                  </div>
                  <div class="account_selector_popup_box account_selector_popup_box2"
                    v-if="!scope.$index && showAllTargetPopup">
                    <div class="text-left">
                      整体ROI目标
                    </div>
                    <div>
                      <el-input type="number" @blur="inputBlur(0)" @input="inputRoiTarget"
                        :class="{ 'no-input': noRoiTarget }" class="responsiveInput4" v-model="roiTarget"
                        placeholder="请输入整体ROI目标 "></el-input>
                    </div>
                    <div v-if="noRoiTarget" class="c_ff3939 text-left">
                      {{ roiTarget ? '整体ROI目标必须在0.01-10000之间' : '请输入整体ROI目标' }}
                    </div>
                    <div class="text-left pt10">
                      日预算
                    </div>
                    <div class="relative pt5">
                      <el-input type="number" @blur="inputBlur(1)" @input="inputBudget"
                        :class="{ 'no-input': nodayBudget }" class="responsiveInput4" suffix-icon="元"
                        v-model="dayBudget" placeholder="请输入日预算 "></el-input>
                      <div class="yuan_box">
                        元
                      </div>
                    </div>

                    <div v-if="nodayBudget" class="c_ff3939 text-left">
                      {{ dayBudget ? '日预算必须在300-999999999.99之间' : '请输入整体日预算' }}
                    </div>
                    <div class="setChooseBox flex alcenter pt10">
                      <div>
                        <el-radio ref="radio" size="medium" v-model="choosedBudgetType" :label="0" class="no-label">
                        </el-radio>
                        <span class="fs14">仅应用于未设置</span>
                      </div>
                      <div class="pl10">
                        <el-radio ref="radio" size="medium" v-model="choosedBudgetType" :label="1" class="no-label">
                        </el-radio>
                        <span class="fs14">应用于全部</span>
                      </div>
                    </div>
                    <div class="flex-end pt20">
                      <el-button size="small" round @click.stop="showAllTargetPopup = null">取消</el-button>
                      <el-button type="primary" size="small" round @click="confirmBudget(false, 0)">确定</el-button>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- 执行时数据 -->
            <el-table-column v-else-if="item.executeData" :key="index" :prop="item.field" :label="item.label"
              :width="item.width" align="center">
              <template slot-scope="scope" v-if="scope.row.reportDesc">
                <div class="">
                  消耗={{ scope.row.reportDesc[0] }}
                  <div>
                    整体支付ROI={{ scope.row.reportDesc[1] }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- 整体ROI目标 -->
            <el-table-column v-else-if="item.totalRoiTarget" :key="index" :prop="item.field" :label="item.label"
              :width="item.width" align="center">
              <template slot-scope="scope" v-if="scope.row.reportDesc">
                <div class="">
                  {{ scope.row.reportDesc[2] }} -> {{ scope.row.reportDesc[3] }}
                </div>
              </template>
            </el-table-column>
            <!-- 佣金率 -->
            <el-table-column v-else-if="item.input" :key="index" :prop="item.field" :label="item.label"
              :width="item.width" align="center">
              <template slot-scope="scope">
                <el-input @blur="checkCommission" type="number" v-model="scope.row[item.field]"
                  :placeholder="item.placeholder"></el-input>
              </template>
            </el-table-column>
            <el-table-column v-else :key="index" :prop="item.field" :label="item.label" :width="item.width"
              :min-width="item.minWidth"
              align="center" :sortable="item.sortable" :label-class-name="item.center === false ? 'cell-center' : ''"
              :class-name="item.center === false ? 'cell-no-center' : ''">
              <template slot-scope="scope">
                <span v-if="item.formatter">{{ item.formatter(scope.row, scope.row[item.field]) }}</span>
                <span v-else-if="item.lineFeed" v-html="lineFeed(scope.row[item.field])" />
                <span v-else-if="item.toHtml" v-html="scope.row[item.field]" />
                <span v-else>{{ scope.row[item.field] }}</span>
              </template>
            </el-table-column>
          </template>
        </template>

        <el-table-column v-if="url.update || url.delete || url.delete2 || operate.length > 0" label="操作"
          :width="operateLength ? operateLength : operate.length < 1 ? 150 : operate.length > 1 ? 200 : 155"
          align="center">
          <template slot-scope="scope">
            <el-button v-if="updatePermission && url.update && canOperateRow(scope.row)" icon="el-icon-edit" @click="openUpdateDV(scope.row)"
              type="text" size="small">编辑
            </el-button>

            <!--通过 operate 新增的操作按钮-->
            <template v-for="(item, index) in operate">
              <template v-if="item.title">
                <template v-if="item.dynamic">
                  <el-popconfirm v-if="canOperateRow(scope.row) && (item.exist ? item.exist(scope.row) : true)" :key="index"
                    :title="item.title(scope.row)" @onConfirm="item.handle(scope.row)">
                    <el-button slot="reference" :icon="item.icon(scope.row)" :type="item.type" size="small"
                      class="ml-10">{{ item.text(scope.row) }}
                    </el-button>
                  </el-popconfirm>
                </template>
                <template v-else>
                  <el-popconfirm v-if="canOperateRow(scope.row) && (item.exist ? item.exist(scope.row) : true)" :key="index" :title="item.title"
                    @onConfirm="item.handle(scope.row)">
                    <el-button slot="reference" :icon="item.icon" :type="item.type" size="small" class="ml-10">{{
                      item.text }}
                    </el-button>
                  </el-popconfirm>
                </template>
              </template>

              <!--没有 item.title 的操作按钮-->
              <el-upload v-else-if="canOperateRow(scope.row) && item.uploadImg" class="dib" :key="index" :action="item.url"
                :headers="{ Authorization: authorization }" :show-file-list="false" :on-success="item.success">
                <el-button :icon="item.icon" :type="item.type" size="small" class="ml-10"
                  @click="item.handle(scope.row)">
                  {{ item.text }}
                </el-button>
              </el-upload>
              <!--没有 item.title 的操作按钮-->
              <el-upload v-else-if="canOperateRow(scope.row) && item.uploadVideo" class="dib" :key="index" :action="item.url"
                :headers="{ Authorization: authorization }" :show-file-list="false" :on-success="item.success"
                :before-upload="(file) => uploadVideo(file, scope.row)">
                <el-button :icon="item.icon" :type="item.type" size="small" class="ml-10"
                  @click="item.handle(scope.row)">
                  {{ item.text }}
                </el-button>
              </el-upload>

              <template v-else>
                <el-button
                  v-if="item.exist ? item.exist(scope.row) : item.exist2 ? scope.row.remark ? scope.row.remark.includes('商品Id') : false : true"
                  slot="reference" :key="index" :icon="item.icon" :type="item.type" size="small" class="ml-10"
                  :class="{ 'noVideoColor': (item.playVideo && !scope.row.path) || (item.bindWx && scope.row.openId) }"
                  @click="item.handle(scope.row)">
                  <span v-if="item.playVideo">
                    {{ scope.row.path ? item.text : '视频链接为空' }}
                  </span>
                  <span v-else-if="item.playVideo2">
                    {{ scope.row.url ? item.text : '视频链接为空' }}
                  </span>
                  <span v-else-if="item.bindWx">
                    {{ scope.row.openId ? '已绑定微信' : '绑定微信' }}
                  </span>
                  <span v-else>
                    {{ item.text }}
                  </span>
                </el-button>

              </template>
            </template>

            <el-popconfirm v-if="deletePermission && url.delete && canOperateRow(scope.row)" :title="'确定要删除吗？'" @onConfirm="deleteRole(scope.row)">
              <el-button slot="reference" icon="el-icon-delete" type="text" size="small" class="text-danger ml-10">
                删除
              </el-button>
            </el-popconfirm>
            <div class="flex-center c_ddd " v-if="deletePermission && url.delete2 && canOperateRow(scope.row)">
              {{ pageName == 'UniPromotionNew' ? '应用到其他抖音号' : '' }}
              <!-- <el-popconfirm :title="'确定要删除吗？'" @onConfirm="deleteRole(scope.row)"> -->
              <el-button v-if="!scope.row.beforeEditAllBudget" slot="reference" type="text" size="small"
                class="c_346bf6 ml-10 fs15" @click="deleteData(scope.$index)">
                <!-- 添加 -->
                删除
              </el-button>
              <!-- </el-popconfirm> -->

            </div>

          </template>
        </el-table-column>
      </el-table>
      <div class="loadingMoreBox" v-if="loadingMore && tableData.length" @click="getMoreData">
        <div class="totalBox">
          目前有 {{ tableData.length }} 条
        </div>
        <div v-if="page.hasMore" class="c_409EFF">
          点击加载更多
        </div>
        <div v-else>
          暂无更多
        </div>
      </div>
      <!--分页条-->
      <div class="pagination"
        v-if="!loadingMore && pageName !== 'UniPromotionNew' && pageName !== 'commissionRateConfiguration'">
        <el-pagination class="flex_wrap flex " :small="isPageSmall" background @size-change="sizeChange"
          @current-change="currentChange" :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size"
          :total="page.totalSize" layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
      <div v-if="pageName == 'UniPromotionNew' || pageName == 'commissionRateConfiguration'">
        <div v-if="!route_params.advertiserName || pageName == 'commissionRateConfiguration'">
          <div class="flex-center pt30">
            <i class="el-icon-circle-plus c_346bf6" style="transform: scale(2.5);" @click="addMoreData"></i>
          </div>
          <div class="flex-end  pt20" :class="isPageSmall ? 'pr20' : 'pr100'">
            <el-button class="responsiveButton" type="primary" @click="submitAll"> {{ pageName ==
              'commissionRateConfiguration' ? '保存配置' : '提交所有推广' }} </el-button>
          </div>
        </div>
        <div v-else>
          <div class="flex-end pr100 pt30">
            <el-button class="responsiveButton" type="primary" @click="submitEdit">提交编辑</el-button>
          </div>
        </div>
      </div>

    </div>

    <!--添加模态框-->
    <div class="dialog">
      <el-dialog :title="formFields.addTitle" @close="resetForm('addForm')" :visible.sync="addVisible"
        custom-class="common-dialog" :close-on-click-modal="false" :width="isPageSmall ? '80%' : '30%'">
        <div class="dialog_body">
          <guide-panel v-if="resolvedAddGuide" class="form-guide-panel" :title="resolvedAddGuide.title"
            :summary="resolvedAddGuide.summary" :points="resolvedAddGuide.points || []"
            :tone="resolvedAddGuide.tone || 'info'" :icon="resolvedAddGuide.icon || 'el-icon-info'" />
          <el-form class="common-table-form" label-position="right" status-icon
            :label-width="formFields.labelWidth ? formFields.labelWidth : '120px'" :model="addForm" ref="addForm">
            <el-form-item v-for="(item, index) in addFormFields" :key="index"
              :label="item.isChange ? addForm.roiType == 1 ? item.label : '' : item.label" :prop="item.field"
              :rules="item.rules" :class="{ 'notExist': item.isChange && addForm.roiType !== 1 }"
              :label-width="item.labelWidth || null">
              <template slot="label" v-if="item.isCheck">
                <el-checkbox v-model="addForm[item.checkField]" class="mr5"></el-checkbox>
                <span>{{ item.label }}</span>
              </template>
              <el-input v-if="item.type === 'password'" type="password" size="medium" v-model="addForm[item.field]"
                clearable autocomplete="off" :placeholder="item.placeholder" show-password
                onblur="this.value=this.value.replace(/[\u4E00-\u9FA5]/g,'')" />
              <el-date-picker v-else-if="item.type === 'dateTime'" v-model="addForm[item.field]"
                :placeholder="item.placeholder" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" align="right"
                size="medium" class="mr10 mb-10" />

              <template v-else-if="item.type === 'select'">
                <div v-if="item.isSelectAll" class="flex alcenter pb10">
                  <div class="selectBtn mr10" @click="selectAccountChange(1, item.field, item.selectData)">全选</div>
                  <div class="selectBtn" @click="selectAccountChange(2, item.field, item.selectData)">取消全选</div>
                </div>
                <el-select size="medium" @change="formSelectChange($event, item.field)" v-model="addForm[item.field]"
                  :placeholder="item.placeholder" :multiple="item.multiple" clearable :filterable="item.filterable"
                  :disabled="item.add && item.add.disabled ? item.add.disabled : false
                    ">
                  <el-option v-for="(option, index) in item.selectData" :key="index" :label="option.name"
                    :value="option.id" />
                </el-select>
              </template>

              <el-input v-else-if="item.type === 'number'" size="medium" :maxlength="item.maxlength" clearable
                v-model.number="addForm[item.field]" type="number" :placeholder="item.placeholder" autocomplete="off"
                :min="item.min" />
              <el-input v-else-if="item.type === 'money'" size="medium" v-model="addForm[item.field]" autocomplete="off"
                :placeholder="item.placeholder" />
              <tinymce v-else-if="item.type === 'editor' || item.type === 'htmlEditor'"
                :id="'tinymceadd1_' + tinymceFlag" :key="tinymceFlag" v-model="addForm[item.field]"
                :value="addForm[item.field]" :height="300" />

              <el-input v-else-if="item.type === 'textarea'" type="textarea" size="medium"
                :autosize="{ minRows: item.minRows }" :placeholder="item.placeholder" v-model="addForm[item.field]"
                clearable>33
              </el-input>
              <template v-else-if="item.type === 'code'">
                <el-col :span="11" style="margin-right: 10px">
                  <el-input v-model="addForm[item.field]" :placeholder="item.placeholder"
                    :disabled="item.add.disabled"></el-input>
                </el-col>
                <el-col :span="11">
                  <el-button type="primary" @click="getCode(item.add.url, item.add.second)" :disabled="btnCodeDisabled">
                    {{ codeName }}
                  </el-button>
                </el-col>
              </template>
              <template v-else-if="item.type === 'checkbox'">
                <el-checkbox v-if="item.isShowByOtherField ? addForm[item.isShowByOtherField] : true" class="fs12"
                  v-model="addForm[item.field]">{{ item.label2 }}</el-checkbox>
              </template>
              <el-input v-else-if="item.isChange ? addForm.roiType == 1 ? true : false : true" size="medium"
                v-model="addForm[item.field]" autocomplete="off" clearable :placeholder="item.placeholder" />
              <guide-panel
                v-if="item.guide && (!item.guide.showByField || addForm[item.guide.showByField])"
                class="field-guide-panel"
                :title="item.guide.title"
                :summary="item.guide.summary"
                :points="item.guide.points || []"
                :tone="item.guide.tone || 'info'"
                :dense="true"
              />
              <div v-if="item.isShowByOtherField ? addForm[item.isShowByOtherField] : item.tip" class="field-tip"
                v-html="lineFeed(item.tip)" />
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="addVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="addFormData('addForm')">确 定
          </el-button>
        </div>
      </el-dialog>
    </div>

    <!--编辑模态框-->
    <div class="dialog">
      <el-dialog :title="formFields.updateTitle" :visible.sync="updateVisible" custom-class="common-dialog"
        :close-on-click-modal="false" :width="isPageSmall ? '80%' : '30%'">
        <div class="dialog_body">
          <guide-panel v-if="resolvedUpdateGuide" class="form-guide-panel" :title="resolvedUpdateGuide.title"
            :summary="resolvedUpdateGuide.summary" :points="resolvedUpdateGuide.points || []"
            :tone="resolvedUpdateGuide.tone || 'info'" :icon="resolvedUpdateGuide.icon || 'el-icon-info'" />
          <el-form class="common-table-form" label-position="right" status-icon
            :label-width="formFields.labelWidth ? formFields.labelWidth : '120px'" :model="updateForm" ref="updateForm">
            <el-form-item v-for="(item, index) in updateFormFields" :key="index"
              :label="item.isChange ? updateForm.roiType == 1 ? item.label : '' : item.label" :prop="item.field"
              :rules="item.rules" :label-width="item.labelWidth || null"
              :class="{ 'notExist': item.isChange && updateForm.roiType !== 1 }">
              <template slot="label" v-if="item.isCheck">
                <el-checkbox v-model="updateForm[item.checkField]" class="mr5"></el-checkbox>
                <span>{{ item.label }}</span>
              </template>
              <el-input v-if="item.type === 'password'" type="password" size="medium" v-model="updateForm[item.field]"
                autocomplete="off" :placeholder="item.placeholder" show-password clearable :disabled="item.update && item.update.disabled
                  ? item.update.disabled
                  : false
                  " onblur="this.value=this.value.replace(/[\u4E00-\u9FA5]/g,'')" />
              <el-select v-else-if="item.type === 'select'" size="medium" v-model="updateForm[item.field]" clearable
                :filterable="item.filterable" :disabled="item.update && item.update.disabled
                  ? item.update.disabled
                  : false
                  " :placeholder="item.placeholder">
                <el-option v-for="(option, index) in item.selectData" :key="index" :label="option.name"
                  :value="option.id" />
              </el-select>
              <el-input v-else-if="item.type === 'number'" size="medium" :maxlength="item.maxlength" clearable
                v-model.number="updateForm[item.field]" :placeholder="item.placeholder" autocomplete="off" :disabled="item.update && item.update.disabled
                  ? item.update.disabled
                  : false
                  " type="number" />
              <el-input v-else-if="item.type === 'textarea'" type="textarea" size="medium" autosize
                :placeholder="item.placeholder" v-model="updateForm[item.field]" clearable :disabled="item.update && item.update.disabled
                  ? item.update.disabled
                  : false
                  ">
              </el-input>
              <el-input v-else-if="item.isChange ? updateForm.roiType == 1 ? true : false : item.type === 'input'"
                size="medium" v-model="updateForm[item.field]" :style="item.onlyShow ? 'pointer-events: none;' : ''"
                autocomplete="off" :placeholder="item.placeholder" :disabled="item.update && item.update.disabled
                  ? item.update.disabled
                  : false
                  " :type="item.inputType || 'text'" :min="item.min" />
              <el-input v-else-if="item.type === 'money'" size="medium" v-model="updateForm[item.field]"
                :style="item.onlyShow ? 'pointer-events: none;' : ''" autocomplete="off" :placeholder="item.placeholder"
                clearable :disabled="item.update && item.update.disabled
                  ? item.update.disabled
                  : false
                  " />
              <tinymce v-else-if="item.type === 'editor' || item.type === 'htmlEditor'"
                :id="'tinymce_' + tinymceFlag + updateForm.id" :key="tinymceFlag" v-model="updateForm[item.field]"
                :value="updateForm[item.field]" :height="300" />
              <el-date-picker v-else-if="item.type === 'dateTime'" v-model="updateForm[item.field]"
                :placeholder="item.placeholder" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" align="right"
                size="medium" @change="elDatePickerChange" class="mr10 mb-10" />
              <template v-else-if="item.type === 'code'">
                <el-col :span="11" style="margin-right: 10px">
                  <el-input v-model="updateForm[item.field]" :placeholder="item.placeholder"
                    :disabled="item.update.disabled"></el-input>
                </el-col>
                <el-col :span="11">
                  <el-button type="primary" @click="getCode(item.update.url, item.update.second)"
                    :disabled="btnCodeDisabled">{{ codeName }}
                  </el-button>
                </el-col>
              </template>
              <template v-else-if="item.type === 'checkbox'">
                <el-checkbox class="fs12" v-if="item.isShowByOtherField ? updateForm[item.isShowByOtherField] : true"
                  v-model="updateForm[item.field]">{{ item.label2 }}</el-checkbox>
              </template>
              <guide-panel
                v-if="item.guide && (!item.guide.showByField || updateForm[item.guide.showByField])"
                class="field-guide-panel"
                :title="item.guide.title"
                :summary="item.guide.summary"
                :points="item.guide.points || []"
                :tone="item.guide.tone || 'info'"
                :icon="item.guide.icon || 'el-icon-info'"
                :dense="true"
              />
              <div v-if="item.isShowByOtherField ? updateForm[item.isShowByOtherField] : item.tip" class="field-tip"
                v-html="lineFeed(item.tip)" />
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="updateVisible = false">取 消
          </el-button>
          <el-popconfirm :title="'确定更新？'" @onConfirm="updateFormData('updateForm')">
            <el-button slot="reference" size="small" type="primary" class="ml-10">更 新
            </el-button>
          </el-popconfirm>
        </div>
      </el-dialog>
    </div>
    <audio controls="controls" hidden :src="require('@/static/msgPrompt.mp3')" ref="audio"></audio>
  </div>
</template>

<script>
import axios from 'axios'
import OSS from 'ali-oss'
// import path from 'path'
import Tinymce from '@/components/Tinymce'
import GuidePanel from '@/components/GuidePanel/GuidePanel'
const synth = window.speechSynthesis // 启用文本
const msg = new SpeechSynthesisUtterance()

import loading3 from "@/utils/loading"

const REMOTE_SELECT_PAGE_SIZE = 30

export default {
  name: 'CommonTable',
  components: {
    Tinymce,
    GuidePanel,
  },

  // tableColumns 属性
  // tableColumns 为表格的列，基础属性为
  // field(表格列 prop 要绑定的属性值),
  // label(表格列 label 要绑定的属性值),
  // show(是否显示),
  // width(列宽)
  // 其他特殊的属性，如图片，加一个 img: true 表示为图片，表示状态 则为 status: true，

  // url 链接的属性有
  // get: '',获取
  // add: '',添加
  // update: '',更新
  // delete: '',删除
  // delete_batch: '',批量删除
  // status: ''，状态更改
  // 不需要全写，只需要写有需要的即可

  // operate 的属性有
  // icon: '',图标
  // type: '',按钮类型
  // text: '',按钮文字
  // title: '',按钮提示标题
  // handle: (row) => {}，操作方法

  // formFields 为模态框及form表单的属性，有 ：
  // 1、addTitle: ''添加模态框的标题,
  // 2、updateTitle: ''更新模态框的标题,
  // 3、model 为表单的字段集，字段如下
  // field: '',字段名，如 field: 'username'
  // label: '',字段标题
  // type: '',输入框类型，有 password，input，number，select
  // selectData:[]，当输入框类型为select时需要添加该字段，
  // placeholder: '', 输入框未输入时显示的文字
  // rules: [{}],该输入框校验规则
  // add: true,是否为可添加
  // update: false,是否为可修改
  props: {
    tableColumns: Array,
    url: Object,
    operate: Array,
    formFields: Object,
    permission: Object,
    searchs: Array,
    autoUpdate: Boolean,
    buttons: Array,
    loadingMore: String,
    limitHeight: Boolean,
    hideTable: Boolean,
    operateLength: Number,
    pageName: String,
    advertiserId: Number,
    advertiserName: String,
    beforeGetData: Function,
    saveSelectObj: {
      type: Object,
      default: () => ({})
    },
    savePromotionConfigObj: {
      type: Object,
      default: () => ({})
    },
    route_params: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    const self = this
    return {
      order: null,
      sort: null,
      getDataNum: 0,
      isNoData: false,
      isSelectAll: '',
      isPageSmall: false,
      loading2: false,
      selectData: [],
      lastValidUniPromotionSelectData: null,
      maxUniPromotionSelectableDays: 30,
      selectedPlanStatus: null,
      showFilterPopup: false,
      selectedConsumeStatus: null,
      selectedSearchPlanStatus: 'AD',
      searcPlaceholder: '',
      searchPlanKeyWord: '',
      remoteSearchSelectStates: {},
      pickerOptions: {
        disabledDate(time) {
          if (self.pageName !== 'UniPromotion') {
            return false
          }
          const today = new Date()
          today.setHours(23, 59, 59, 999)
          const earliest = new Date()
          earliest.setHours(0, 0, 0, 0)
          earliest.setDate(earliest.getDate() - (self.maxUniPromotionSelectableDays - 1))
          return time.getTime() < earliest.getTime() || time.getTime() > today.getTime()
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setHours(0, 0, 0, 0);  // 今天00:00:00
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const end = new Date();
            end.setDate(end.getDate() - 1);
            end.setHours(23, 59, 59, 999);  // 昨天23:59:59.999
            const start = new Date(end);
            start.setHours(0, 0, 0, 0);  // 昨天00:00:00
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '近3天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setDate(start.getDate() - 2);  // 3天前（含今天）
            start.setHours(0, 0, 0, 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '近7天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setDate(start.getDate() - 6);  // 7天前（含今天）
            start.setHours(0, 0, 0, 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '近15天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setDate(start.getDate() - 14);  // 15天前（含今天）
            start.setHours(0, 0, 0, 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '近30天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setDate(start.getDate() - 29);  // 30天前（含今天）
            start.setHours(0, 0, 0, 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '上周',
          onClick(picker) {
            const today = new Date();
            const day = today.getDay(); // 本周的第几天（0=周日）
            const diff = day === 0 ? 6 : day - 1; // 到上周一的天数差

            const end = new Date(today);
            end.setDate(today.getDate() - diff - 1); // 上周日
            end.setHours(23, 59, 59, 999);

            const start = new Date(end);
            start.setDate(end.getDate() - 6); // 上周一
            start.setHours(0, 0, 0, 0);

            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '本月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setDate(1);  // 本月1号
            start.setHours(0, 0, 0, 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '上月',
          onClick(picker) {
            const end = new Date();
            end.setMonth(end.getMonth(), 0);  // 上月最后一天
            end.setHours(23, 59, 59, 999);

            const start = new Date(end);
            start.setDate(1);  // 上月1号
            start.setHours(0, 0, 0, 0);

            picker.$emit('pick', [start, end]);
          }
        }]
      },
      consumeOptions: [{
        value: 'ALL',
        label: '全部'
      }, {
        value: 'YES',
        label: '有消耗'
      }, {
        value: 'NO',
        label: '无消耗'
      }],
      searchPlanOptions: [{
        value: 'AD',
        label: '计划'
      }, {
        value: 'PRODUCT',
        label: '商品'
      }, {
        value: 'AWEME',
        label: '抖音号'
      }],
      planOptions: [{
        value: 'DELIVERY_OK',
        label: '投放中'
      }, {
        value: 'AUDIT',
        label: '新建审核中'
      }, {
        value: 'REAUDIT',
        label: '修改审核中'
      }, {
        value: 'OFFLINE_AUDIT',
        label: '审核不通过'
      }, {
        value: 'DISABLE',
        label: '已暂停'
      }, {
        value: 'DELETED',
        label: '已删除'
      }, {
        value: 'TIME_DONE',
        label: '已完成'
      }, {
        value: 'ALL_INCLUDE_DELETED',
        label: '全部（包含已删除）'
      }, {
        value: 'FROZEN',
        label: '已终止'
      }],
      activeType: 0,
      selectStartData: '',
      selectEndData: '',
      accountList: [],
      dyNumberList: [],
      searchDYNumber: null,
      searchDYNumberList: [],
      searchAccountList: [],
      searchAccountTimer: null,
      searchAccountRequestId: 0,
      accountScrollPage: 1,
      accountScrollHasMore: true,
      accountScrollLoading: false,
      searchAccountScrollPage: 1,
      searchAccountScrollHasMore: true,
      searchAccountScrollLoading: false,
      selectedDYNumber: null,
      choosedBudgetType: 0,
      searchAccount: null,
      showPopup: null,
      showNumberPopup: null,
      showTargetPopup: null,
      showAllTargetPopup: null,
      roiTarget: '',
      dayBudget: '',
      nodayBudget: false,
      noRoiTarget: false,
      choosed_box: 0,
      pageIndex: 1,
      dialogVisible: false,
      selectedImage: '',
      // 当前提现订单数量
      totalElements: null,
      play: false,
      // 查询数据
      query: {},
      tinymceFlag: 1,
      //表格数据
      tableData: [],
      //分页
      page: {
        //当前页
        current: 1,
        //当前每页显示条数
        size: 10,
        //可选数据显示条数
        sizes: [10, 20, 30, 40, 50, 100],
        //总数据条数
        totalSize: 0,
        //总页数
        totalPages: 0,
        //实际显示条数
        realSize: 0,
      },
      editor: {
        left: 'undo redo clear | h bold italic strikethrough quote | ul ol table hr | link image code',
        toolbar: {},
        toolbarConfig: {
          'image-link': {
            // 是否在插入图片链接的时候默认带上width height 属性，默认值：false
            insertWithSize: true,
          },
        },
      },
      qrCodeUrl: this.reUrl + '/adminInfo/qrCode?key=',
      authorization: this.$store.state.sessionId,
      time: [],
      //表格被选中的数据id
      selectedIds: [],
      selectProductIds: [],
      selectadIds: [],
      //添加的表单
      addForm: {},
      //更新的表单
      updateForm: {},
      // 添加模态框是否显示
      addVisible: false,
      // 更新模态框是否显示
      updateVisible: false,
      // 添加的权限
      addPermission: false,
      // 修改的权限
      updatePermission: false,
      // 删除的权限
      deletePermission: false,
      // 批量删除添加的权限
      deleteBatchPermission: false,
      // 所有权限
      permissions: [],
      codeName: '获取验证码',
      btnCodeDisabled: false,
    }
  },
  computed: {
    //从 formFields 获取添加表单的列表数据
    addFormFields() {
      return this.formFields.model.filter((column) => {
        return column.add
      })
    },
    //从 formFields 获取添加表单的列表数据
    updateFormFields() {
      return this.formFields.model.filter((column) => {
        return column.update
      })
    },
    resolvedAddGuide() {
      return this.formFields.addGuide || null
    },
    resolvedUpdateGuide() {
      return this.formFields.updateGuide || this.formFields.addGuide || null
    },
    //从 formFields 获取select列表框数据
    selectFields() {
      return this.formFields.model.filter((column) => {
        return column.selectUrl
      })
    },

    //从 tableColumns 获取detail的数据
    tableDetailColumns() {
      return this.tableColumns.filter((column) => {
        return column.detail
      })
    },

    tableSelectFields() {
      return this.tableColumns.filter((column) => {
        return column.selectUrl || column.selectData
      })
    },

    searchSelectFields() {
      if (this.pageName == 'contacts') {
        return [{}, {
          name: 'createPerson',
          placeholder: '创建人',
          type: 'select',
          select: true,
          selectUrl: '/agent/getAll',
          selectData: []
        }]
      }
      return (
        this.searchs &&
        this.searchs.filter((column) => {
          return column.selectUrl || column.selectValue
        })
      )
    },
    isAdmin() {
      try {
        const adminInfo = localStorage.getItem('adminInfo');
        if (adminInfo) {
          const info = JSON.parse(adminInfo);
          return info.type == 1;
        }
      } catch (e) {
        console.error('Failed to parse adminInfo:', e);
      }
      return false;
    },
  },
  created() {
    if (this.searchs) {
      this.searchs.forEach((search) => {
        if (this.isRemoteSearchField(search)) {
          this.$set(search, 'remoteMethod', (keyword) => {
            this.handleRemoteSearch(search, keyword)
          })
        }
      })
    }
    if (this.url.get == '/withdrawal/listByCondition') {
      this.$alert('点击确定允许网站播放放订单提示音', '提示', {
        confirmButtonText: '确定',
        showClose: false,
        callback: () => {
          this.play = true
        },
      })
    }
    if (this.pageName == 'UniPromotionNew') {
      this.getAccountList()
    }



    if (this.pageName == 'budgetRegulation') {
      this.tableData = [{
        ruleName: '可盈利计划预算不足35%翻倍',
        executeAction: '调整且通知',
        monitorWay: '监控80个账户',
        ruleInfo: '当日内，消耗占比>65.0%且ROI>15.0且7日总支付ROI>14.0',
        createPerson: '18075896337（18075896337）'
      }]
    }


  },
  watch: {
    hideTable(newVal) {
      if (!newVal) {
        this.syncTableLayout()
      }
    },
    saveSelectObj: {
      immediate: true,
      handler(newVal, oldVal) {
        console.log(oldVal, newVal, '33333333333')
        if (newVal.list) {
          let { list, index } = newVal
          this.$set(this.tableData[index], 'selectedList', list)
          if (newVal.rowPatch) {
            Object.keys(newVal.rowPatch).forEach((key) => {
              this.$set(this.tableData[index], key, newVal.rowPatch[key])
            })
          }
        }

      }
    },
    savePromotionConfigObj: {
      immediate: true,
      handler(newVal) {
        if (!newVal || newVal.index === undefined || !newVal.rowPatch) {
          return
        }
        Object.keys(newVal.rowPatch).forEach((key) => {
          this.$set(this.tableData[newVal.index], key, newVal.rowPatch[key])
        })
      }
    },
    showNumberPopup: {
      immediate: true,
      handler() {
        // console.log(oldVal, newVal, '2222222')
        if (!this.showNumberPopup) {
          this.searchDYNumber = null
        }

      }
    },
    advertiserId: {
      immediate: true,
      handler() {
        // console.log(oldVal, newVal, '2222222')
        if (this.advertiserId) {
          if (this.pageName == 'UniPromotion') {
            this.tableData = []
            this.activeType = 0
            this.selectedPlanStatus = null
            this.selectStartData = ''
            this.selectEndData = ''
            this.selectedConsumeStatus = null
            console.log('advertiserId变化')
            this.getData()
          }
        }

      }
    },
    tableData: {
      immediate: true,
      deep: true,
      handler() {
        console.log(this.tableData, 'this.tableData')
      }
    },
    $route: {
      immediate: true,
      handler(newRoute) {
        console.log(newRoute.path, newRoute.query, '----------------')
        // 当路由变化时执行，包括path和query的变化
        // console.log('Route changed', newRoute.path, newRoute.query, oldRoute);
        // 在这里处理您的逻辑
        if (newRoute.path == '/qdd/admin/uniPromotion.html' || newRoute.query.isRefreshData) {
          if (!this.advertiserId) return
          if (newRoute.query.advertiserName) return
          console.log('$route1111111')
          this.getData()
        } else if (newRoute.query.getLog) {
          if (!window.location.pathname.includes(this.pageName)) return
          if (this.pageName == 'QianchuanTaskLog') {
            this.$set(this.query, 'advertiserId', newRoute.query.id)
          } else if (this.pageName == 'AdDailyAccountReport') {
            this.$set(this.query, 'reportId', newRoute.query.id)
          } else {
            this.$set(this.query, 'ruleId', newRoute.query.id)

          }
          console.log('this.query', this.query)

          // console.log('$route2222222', window.location.pathname, this.url.get, this.pageName)
          this.getData()
        }

      }
    },
    selectedSearchPlanStatus: {
      immediate: true,
      deep: true,
      handler() {
        if (this.selectedSearchPlanStatus == 'AD') {
          this.searcPlaceholder = '计划'
        } else if (this.selectedSearchPlanStatus == 'PRODUCT') {
          this.searcPlaceholder = '商品'
        } else if (this.selectedSearchPlanStatus == 'AWEME') {
          this.searcPlaceholder = '抖音号'
        }
      }
    },
    route_params: {
      immediate: true,
      deep: true,
      handler() {
        console.log(this.route_params, this.route_params.getLog, 'this.route_params1111111')
        if (this.route_params.advertiserName) {
          setTimeout(() => {
            let selectedCreatives = []
            if (this.route_params.selectedCreatives) {
              try {
                selectedCreatives = JSON.parse(this.route_params.selectedCreatives)
              } catch (e) {
                console.error('Failed to parse selectedCreatives:', e)
              }
            }
            let account_data = {
              id: this.route_params.advertiserId,
              name: this.route_params.advertiserName
            }
            this.getDYNumberList(this.route_params.advertiserId, 0, true)
            let AllBudget_data = {
              dayBudget: this.route_params.budget,
              roiTarget: this.route_params.roi2Goal,
              scheduleType: this.route_params.scheduleType !== 'false',
              startTime: this.route_params.startTime || null,
              endTime: this.route_params.endTime || null,
            }
            let roomInfo = JSON.parse(this.route_params.roomInfo)
            let selectDYNumber_data = {
              id: roomInfo[0].anchorId,
              name: roomInfo[0].anchorName
            }

            let productInfo = JSON.parse(this.route_params.productInfo)
            if (!this.tableData[0]) {
              let object = {
                account: account_data,
                AllBudget: AllBudget_data,
                selectedDYNumber: selectDYNumber_data,
                selectedList: productInfo,
                editList: productInfo,
                selectedCreatives,
                deliveryMode: this.route_params.deliveryMode || 'COST',
                materialMode: this.route_params.materialMode || 'AUTO',
                isEdit: true,
                adId: this.route_params.adId,
                beforeEditAllBudget: AllBudget_data,
                planName: this.route_params.name
              }
              console.log(object, 'object')
              this.tableData.push(object)
              return
            }
            this.$set(this.tableData[0], 'account', account_data)
            this.$set(this.tableData[0], 'AllBudget', AllBudget_data)
            this.$set(this.tableData[0], 'selectedDYNumber', selectDYNumber_data)
            this.$set(this.tableData[0], 'selectedList', productInfo)
            this.$set(this.tableData[0], 'editList', productInfo)
            this.$set(this.tableData[0], 'selectedCreatives', selectedCreatives)
            this.$set(this.tableData[0], 'deliveryMode', this.route_params.deliveryMode || 'COST')
            this.$set(this.tableData[0], 'materialMode', this.route_params.materialMode || 'AUTO')
            this.$set(this.tableData[0], 'isEdit', true)
            this.$set(this.tableData[0], 'adId', this.route_params.adId)
            this.$set(this.tableData[0], 'beforeEditAllBudget', AllBudget_data)
            this.$set(this.tableData[0], 'planName', this.route_params.name)
          }, 10)
        } else if (this.route_params.id) {
          console.log('$route_params', window.location.pathname, this.url.get, this.pageName)
          if (!window.location.pathname.includes(this.pageName)) return
          setTimeout(() => {
            console.log(' this.getDYNumberList(this.route_params.id, 0)')
            this.getDYNumberList(this.route_params.id, 0)
            console.log(this.tableData[0], 'this.tableData[0]this.tableData[0]')
            if (!this.tableData[0]) {
              let object = {
                account: this.route_params
              }
              console.log(object, 'object')
              this.tableData.push(object)
              return
            }
            this.$set(this.tableData[0], 'account', this.route_params)
          }, 10)
        }

      }
    },
  },
  mounted() {
    this.getUserPermissions()
    this.resizeHandler()
    console.log(this.buttons, 'buttonsssssssssssss')
    //this.getSelectData();
    //this.getTableSelectData();
    //this.getSearchSelectData();
    if (this.autoUpdate) {
      this.timer = setInterval(this.getDateFunction, 5000)
    }
    setTimeout(() => {
      this.tinymceFlag++
    }, 1000)
    if (this.pageName == 'accountNew' || this.pageName == 'materialNew') {
      this.$set(this.query, 'selectDateRange', 0)
    }

    this.debouncedResize = this.debounce(this.resizeHandler, 50);
    window.addEventListener('resize', this.debouncedResize);
    //console.log(this.$route)

  },
  beforeDestroy() {
    window.removeEventListener('resize', this.debouncedResize);
    if (this.autoUpdate) {
      clearInterval(this.timer)
    }
    if (this.searchAccountTimer) {
      clearTimeout(this.searchAccountTimer)
    }
    this.clearAllRemoteSearchScrollListeners()
  },
  activated() {
    this.tinymceFlag++
    let params = this.$route.params
    if (params) {
      Object.keys(params).forEach((key) => {
        this.query[key] = params[key]
      })
      this.$set(this.page, 'cursor', 0)
      if (this.pageName !== 'UniPromotionNew' && this.pageName !== 'commissionRateConfiguration') {
        if (this.pageName !== 'UniPromotion') {
          console.log('activated')
          this.getData()
        }
      } else {
        if (this.pageName == 'commissionRateConfiguration') {
          this.tableData = [
            { minCommission: '', maxCommission: '', targetRoi: '' }
          ]

          this.getNewCommissionRoi()
          return
        }
        this.tableData = [{}]
      }
    }
    this.getSelectData()
    this.getTableSelectData()
    this.getSearchSelectData()
  },
  methods: {
    syncTableLayout() {
      this.$nextTick(() => {
        if (this.hideTable) {
          return
        }
        const tableRef = this.$refs.multipleTable
        if (tableRef && tableRef.doLayout) {
          tableRef.doLayout()
        }
      })
    },
    isSupportedOceanEngineAdvertiserType(accountType) {
      return [1, 6, 7].includes(Number(accountType))
    },
    getOceanEngineAdvertiserUnsupportedMessage(message) {
      const unsupportedMessage = '无法处理的账号类型'
      const currentMessage = message ? String(message).trim() : ''
      if (!currentMessage) {
        return unsupportedMessage
      }
      if (currentMessage.includes(unsupportedMessage)) {
        return currentMessage
      }
      return `${currentMessage}；${unsupportedMessage}`
    },
    decorateOceanEngineAdvertiserRows() {
      if (this.pageName !== 'oceanEngineAdvertiser' || !Array.isArray(this.tableData)) {
        return
      }
      this.tableData = this.tableData.map((row) => {
        if (!row) {
          return row
        }
        const isUnsupportedType =
          row.accountType !== null &&
          row.accountType !== undefined &&
          !this.isSupportedOceanEngineAdvertiserType(row.accountType)

        if (!isUnsupportedType) {
          return row
        }

        return {
          ...row,
          readOnly: true,
          message: this.getOceanEngineAdvertiserUnsupportedMessage(row.message),
        }
      })
    },
    isRowReadOnly(row) {
      if (this.pageName === 'UniPromotion' && Number(this.advertiserId) <= 0) {
        return true
      }
      if (this.pageName !== 'oceanEngineAdvertiser' || !row) {
        return false
      }
      const hasAccountType = row.accountType !== null && row.accountType !== undefined
      return !!row.readOnly || (hasAccountType && !this.isSupportedOceanEngineAdvertiserType(row.accountType))
    },
    canOperateRow(row) {
      return !this.isRowReadOnly(row)
    },
    isRowSelectable(row) {
      return this.canOperateRow(row)
    },
    selectAccountChange(e, field, list) {
      console.log(e, field, this.addForm[field])
      if (e == 1) {
        this.addForm[field] = list.map((account) => {
          return account.id
        });
      } else {
        this.addForm[field] = []
      }
    },
    formSelectChange(e, field) {
      console.log(e, field)
      if (field !== 'roiType') return
      console.log(this.addForm, this.formFields.model, this.addForm.fixedRoi)
      let index = this.formFields.model.findIndex((obj) => obj.field == "fixedRoi")
      if (index == -1) return
      this.formFields.model[index]
      if (e == 1) {
        this.$set(this.formFields.model[index].rules[0], 'required', true)
      } else {
        this.$set(this.formFields.model[index].rules[0], 'required', false)
      }

    },
    // 获得之前的佣金率配置
    getNewCommissionRoi() {
      this.$axios.get({
        url: '/qianchuanCommissionRoi/getTheLatestConfiguration',
        success: (res) => {
          console.log('5555555', res)
          if (res.data && res.data.length) {
            this.tableData = res.data
          }
          //
        },
        error: () => {
          this.$message.error('出错了')
        },
      })
    },
    // 账户报表
    goShowSelectAccountPopup(arr) {
      if (!arr || !arr.length) return
      this.$emit('goShowSelectAccountPopup', arr)
    },

    debounce(fn, delay) {
      let timer = null;
      return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => {
          fn.apply(this, args);
        }, delay);
      };
    },
    isRemoteSearchField(search) {
      return !!(search && search.selectUrl && search.selectUrl.includes('optionsByCondition'))
    },
    getRemoteSearchStateKey(search) {
      if (!search) {
        return ''
      }
      return search.name || search.selectUrl || ''
    },
    ensureRemoteSearchState(search) {
      const stateKey = this.getRemoteSearchStateKey(search)
      if (!stateKey) {
        return {
          keyword: '',
          pageIndex: 1,
          hasMore: false,
          loading: false,
          requesting: false,
          requestId: 0,
          debounceTimer: null,
          scrollWrap: null,
          scrollHandler: null,
        }
      }
      if (!this.remoteSearchSelectStates[stateKey]) {
        this.$set(this.remoteSearchSelectStates, stateKey, {
          keyword: '',
          pageIndex: 1,
          hasMore: true,
          loading: false,
          requesting: false,
          requestId: 0,
          debounceTimer: null,
          scrollWrap: null,
          scrollHandler: null,
        })
      }
      return this.remoteSearchSelectStates[stateKey]
    },
    getRemoteSearchPopperClass(search, index) {
      const key = search && search.name ? search.name : index
      return `common-table-remote-select-${this.pageName || 'default'}-${key}`
    },
    getRemoteSearchMethod(search) {
      return (keyword) => {
        this.handleRemoteSearch(search, keyword)
      }
    },
    getRemoteSearchLoading(search) {
      if (!this.isRemoteSearchField(search)) {
        return false
      }
      return this.ensureRemoteSearchState(search).loading
    },
    handleRemoteSearchVisible(search, index, visible) {
      if (!visible || !this.isRemoteSearchField(search)) {
        return
      }
      const state = this.ensureRemoteSearchState(search)
      if (state.debounceTimer) {
        clearTimeout(state.debounceTimer)
        state.debounceTimer = null
      }
      if (!Array.isArray(search.selectValue) || !search.selectValue.length || state.keyword) {
        this.fetchRemoteSearchOptions(search, {
          keyword: '',
          pageIndex: 1,
          append: false,
          silent: !!(Array.isArray(search.selectValue) && search.selectValue.length),
        })
      }
      this.$nextTick(() => {
        this.bindRemoteSearchScroll(search, index)
      })
    },
    bindRemoteSearchScroll(search, index) {
      if (!this.isRemoteSearchField(search)) {
        return
      }
      const state = this.ensureRemoteSearchState(search)
      const popperClass = this.getRemoteSearchPopperClass(search, index)
      const tryBind = (attempts) => {
        const wrap = document.querySelector(`.${popperClass} .el-select-dropdown__wrap`)
        if (wrap) {
          if (state.scrollWrap === wrap && state.scrollHandler) {
            return
          }
          if (state.scrollWrap && state.scrollHandler) {
            state.scrollWrap.removeEventListener('scroll', state.scrollHandler)
          }
          state.scrollWrap = wrap
          state.scrollHandler = () => {
            if (wrap.scrollHeight - wrap.scrollTop <= wrap.clientHeight + 10) {
              this.loadMoreRemoteSearchOptions(search)
            }
          }
          wrap.addEventListener('scroll', state.scrollHandler)
        } else if (attempts < 8) {
          setTimeout(() => tryBind(attempts + 1), 50)
        }
      }
      tryBind(0)
    },
    clearRemoteSearchScrollListener(search) {
      const state = this.ensureRemoteSearchState(search)
      if (state.debounceTimer) {
        clearTimeout(state.debounceTimer)
        state.debounceTimer = null
      }
      if (state.scrollWrap && state.scrollHandler) {
        state.scrollWrap.removeEventListener('scroll', state.scrollHandler)
      }
      state.scrollWrap = null
      state.scrollHandler = null
    },
    clearAllRemoteSearchScrollListeners() {
      Object.keys(this.remoteSearchSelectStates).forEach((key) => {
        const state = this.remoteSearchSelectStates[key]
        if (!state || !state.scrollWrap || !state.scrollHandler) {
          if (state && state.debounceTimer) {
            clearTimeout(state.debounceTimer)
            state.debounceTimer = null
          }
          return
        }
        state.scrollWrap.removeEventListener('scroll', state.scrollHandler)
        state.scrollWrap = null
        state.scrollHandler = null
        if (state.debounceTimer) {
          clearTimeout(state.debounceTimer)
          state.debounceTimer = null
        }
      })
    },
    buildSearchSelectOptions(field, objs) {
      const list = Array.isArray(objs) ? objs : []
      const options = []
      list.forEach((obj) => {
        options.push({
          value:
            obj.name !== undefined
              ? obj.name
              : obj.username !== undefined
                ? obj.username
                : obj.phone !== undefined
                  ? obj.phone
                  : obj.pid !== undefined
                    ? obj.pid
                    : obj.activityName !== undefined
                      ? obj.activityName
                      : obj.actionName !== undefined
                        ? obj.actionName
                        : obj.number,
          key: obj[field.valueKey] || obj.id,
        })
      })
      return options
    },
    getSelectResponseList(data) {
      if (Array.isArray(data)) {
        return data
      }
      if (data && Array.isArray(data.data)) {
        return data.data
      }
      if (data && Array.isArray(data.content)) {
        return data.content
      }
      return []
    },
    buildLegacySelectOptions(field, objs) {
      const list = Array.isArray(objs) ? objs : []
      const options = []
      list.forEach((obj) => {
        options.push({
          name:
            obj.name !== undefined
              ? obj.name
              : obj.username !== undefined
                ? obj.username
                : obj.pid !== undefined
                  ? obj.pid
                  : obj.activityName !== undefined
                    ? obj.activityName
                    : obj.actionName !== undefined
                      ? obj.actionName
                      : obj.douYinName,
          id: obj[field.valueKey] || obj.id || obj.aweMeId || obj.advertiserId,
        })
      })
      return options
    },
    mergeSearchSelectOptions(existingOptions, nextOptions) {
      const mergedMap = {}
      const mergedOptions = []
      const options = []
        .concat(Array.isArray(existingOptions) ? existingOptions : [])
        .concat(Array.isArray(nextOptions) ? nextOptions : [])
      options.forEach((item) => {
        if (!item) {
          return
        }
        const optionKey = item.key !== undefined && item.key !== null ? String(item.key) : ''
        if (!optionKey || mergedMap[optionKey]) {
          return
        }
        mergedMap[optionKey] = true
        mergedOptions.push(item)
      })
      return mergedOptions
    },
    fetchRemoteSearchOptions(field, options) {
      if (!this.isRemoteSearchField(field)) {
        return
      }
      const state = this.ensureRemoteSearchState(field)
      const pageIndex = options && options.pageIndex ? options.pageIndex : 1
      const keyword = options && options.keyword ? String(options.keyword).trim() : ''
      const append = !!(options && options.append)
      const silent = !!(options && options.silent)
      state.requestId += 1
      const requestId = state.requestId
      state.requesting = true
      state.loading = !silent
      const requestData = {
        pageIndex,
        pageSize: REMOTE_SELECT_PAGE_SIZE,
      }
      if (keyword) {
        requestData.keyword = keyword
      }
      this.$axios.post({
        url: field.selectUrl,
        data: requestData,
        loading: false,
        success: (res) => {
          if (requestId !== state.requestId) {
            return
          }
          state.requesting = false
          state.loading = false
          if (res.code !== 0) {
            this.$message.error(res.msg || '获取数据错误')
            return
          }
          const payload = res.data || {}
          const remoteOptions = this.buildSearchSelectOptions(field, payload.content || [])
          state.keyword = keyword
          state.pageIndex = pageIndex
          state.hasMore = !!payload.hasMore
          this.$set(
            field,
            'selectValue',
            append ? this.mergeSearchSelectOptions(field.selectValue, remoteOptions) : remoteOptions
          )
        },
        error: () => {
          if (requestId !== state.requestId) {
            return
          }
          state.requesting = false
          state.loading = false
          this.$message.error('出错了')
        },
      })
    },
    handleRemoteSearch(search, keyword) {
      if (!this.isRemoteSearchField(search)) {
        return
      }
      const state = this.ensureRemoteSearchState(search)
      if (state.debounceTimer) {
        clearTimeout(state.debounceTimer)
      }
      state.debounceTimer = setTimeout(() => {
        state.debounceTimer = null
        this.fetchRemoteSearchOptions(search, {
          keyword,
          pageIndex: 1,
          append: false,
        })
      }, 200)
    },
    loadMoreRemoteSearchOptions(search) {
      if (!this.isRemoteSearchField(search)) {
        return
      }
      const state = this.ensureRemoteSearchState(search)
      if (state.requesting || !state.hasMore) {
        return
      }
      this.fetchRemoteSearchOptions(search, {
        keyword: state.keyword,
        pageIndex: state.pageIndex + 1,
        append: true,
        silent: true,
      })
    },
    resizeHandler() {
      // 1. 获取视口（可见区域）宽高（常用）
      const viewportWidth = window.innerWidth;   // 视口宽度（不包含滚动条）

      if (viewportWidth < 500) {
        this.isPageSmall = true
      } else {
        this.isPageSmall = false
      }
      this.$emit('isPageSmall', this.isPageSmall)
      this.syncTableLayout()
      // 可根据需要在这里更新表格高度等响应式操作
      // 例如：this.tableHeight = viewportHeight - 200; // 减去固定高度的头部/底部
    },
    addAccountAuthorize() {
      this.$emit('showAccountAuthorize')
    },
    updateAccountInfo() {
      this.$axios.get({
        url: '/oceanEngineAdvertiser/refreshStatus',
        success: (res) => {
          console.log('777777', res)
          if (res.code == 0) {
            this.$message.success("账号状态更新完成")
            this.getData()
          } else {
            this.$message.error('出错了')
          }
        },
        error: () => {
          this.$message.error('出错了')
        },
      })
    },
    handleManualRefreshAll() {
      this.$axios.post({
        url: '/oceanEngineAdvertiser/manualRefreshAllTokens',
        confirm: '确定要手动使用 refreshToken 更新全部账户授权信息吗？此操作会消耗大量 API 请求额度。',
        title: '重要提示',
        success: (res) => {
          if (res.code == 0) {
            this.$message.success('全局刷新任务已启动，请稍后刷新页面查看');
          } else {
            this.$message.error(res.msg || '触发失败');
          }
        },
        error: () => {
          this.$message.error('请求失败，请稍后重试');
        }
      });
    },
    statusName(name) {
      const statusMapping = {
        DELETE: '已删除',
        AUDIT: '新建审核中',
        TIME_DONE: '已完成',
        DISABLE: '已暂停',
        TIME_NO_REACH: '未到达投放时间',
        OFFLINE_BALANCE: '账户余额不足',
        OFFLINE_BUDGET: '广告预算不足',
        DELIVERY_OK: '投放中',
        NO_SCHEDULE: '不在投放时段',
        REAUDIT: '修改审核中',
        OFFLINE_AUDIT: '审核不通过',
        EXTERNAL_URL_DISABLE: '落地页暂不可用',
        LIVE_ROOM_OFF: '关联直播间未开通',
        FROZEN: '已终止',
        SYSTEM_DISABLE: '系统暂停',
        ALL_INCLUDE_DELETED: '全部（包含已删除）',
        QUOTA_DISABLE: '在投计划配额超限',
        ROI2_DISABLE: '全域推广暂停'
      }
      return statusMapping[name]
    },
    addMoreData() {
      if (this.pageName == 'UniPromotionNew') {
        this.tableData.push({})
      } else {
        this.tableData.push({ minCommission: '', maxCommission: '', targetRoi: '' })
      }
      console.log(this.tableData)
    },
    getAccountList() {
      this.accountScrollPage = 1
      this.accountScrollHasMore = true
      this.accountScrollLoading = true
      this.$axios.post({
        url: '/oceanEngineAdvertiser/optionsByCondition',
        data: {
          pageIndex: 1,
          pageSize: 30
        },
        success: (res) => {
          this.accountScrollLoading = false
          if (res.code === 0) {
            const payload = res.data || {}
            this.accountList = Array.isArray(payload.content) ? payload.content : []
            this.accountScrollHasMore = !!payload.hasMore
          } else {
            this.$message.error(res.msg || '获取数据错误')
          }
        },
        error: () => {
          this.accountScrollLoading = false
          this.$message.error('出错了')
        },
      })
    },
    searchAccountInput() {
      const keyword = this.searchAccount ? String(this.searchAccount).trim() : ''
      if (this.searchAccountTimer) {
        clearTimeout(this.searchAccountTimer)
      }
      this.searchAccountRequestId += 1
      const currentRequestId = this.searchAccountRequestId
      
      this.searchAccountList = []
      this.searchAccountScrollPage = 1
      this.searchAccountScrollHasMore = true
      this.searchAccountScrollLoading = false

      if (!keyword) {
        return
      }
      this.searchAccountList = this.accountList.filter((obj) => {
        const name = obj && obj.name ? String(obj.name) : ''
        const advertiserId = obj && obj.advertiserId !== undefined && obj.advertiserId !== null
          ? String(obj.advertiserId)
          : ''
        return name.includes(keyword) || advertiserId.includes(keyword)
      })
      
      this.searchAccountTimer = setTimeout(() => {
        this.searchAccountScrollLoading = true
        this.$axios.post({
          url: '/oceanEngineAdvertiser/optionsByCondition',
          data: {
            keyword,
            pageIndex: 1,
            pageSize: 30
          },
          loading: false,
          success: (res) => {
            if (currentRequestId !== this.searchAccountRequestId) {
              return
            }
            this.searchAccountScrollLoading = false
            if (res.code !== 0) {
              return
            }
            const payload = res.data || {}
            this.searchAccountScrollHasMore = !!payload.hasMore
            const remoteList = payload.content || []
            const mergedMap = {}
            const mergedList = []
            this.searchAccountList.concat(remoteList).forEach((item) => {
              if (!item) return
              const advertiserId = item.advertiserId !== undefined && item.advertiserId !== null
                ? String(item.advertiserId)
                : ''
              if (!advertiserId || mergedMap[advertiserId]) return
              mergedMap[advertiserId] = true
              mergedList.push(item)
            })
            this.searchAccountList = mergedList
          },
          error: () => {
            this.searchAccountScrollLoading = false
          }
        })
      }, 200)
    },
    handleAccountListScroll(e) {
      const target = e.target
      if (target.scrollHeight - target.scrollTop <= target.clientHeight + 10) {
        this.loadNextAccountPage()
      }
    },
    loadNextAccountPage() {
      const keyword = this.searchAccount ? String(this.searchAccount).trim() : ''
      if (keyword) {
        if (!this.searchAccountScrollHasMore || this.searchAccountScrollLoading) {
          return
        }
        this.searchAccountScrollLoading = true
        const nextPage = this.searchAccountScrollPage + 1
        const currentRequestId = this.searchAccountRequestId
        this.$axios.post({
          url: '/oceanEngineAdvertiser/optionsByCondition',
          data: {
            keyword,
            pageIndex: nextPage,
            pageSize: 30
          },
          loading: false,
          success: (res) => {
            if (currentRequestId !== this.searchAccountRequestId) {
              return
            }
            this.searchAccountScrollLoading = false
            if (res.code === 0) {
              const payload = res.data || {}
              const remoteList = payload.content || []
              this.searchAccountScrollPage = nextPage
              this.searchAccountScrollHasMore = !!payload.hasMore
              
              const mergedMap = {}
              const mergedList = []
              this.searchAccountList.concat(remoteList).forEach((item) => {
                if (!item) return
                const advertiserId = item.advertiserId !== undefined && item.advertiserId !== null
                  ? String(item.advertiserId)
                  : ''
                if (!advertiserId || mergedMap[advertiserId]) return
                mergedMap[advertiserId] = true
                mergedList.push(item)
              })
              this.searchAccountList = mergedList
            }
          },
          error: () => {
            this.searchAccountScrollLoading = false
          }
        })
      } else {
        if (!this.accountScrollHasMore || this.accountScrollLoading) {
          return
        }
        this.accountScrollLoading = true
        const nextPage = this.accountScrollPage + 1
        this.$axios.post({
          url: '/oceanEngineAdvertiser/optionsByCondition',
          data: {
            pageIndex: nextPage,
            pageSize: 30
          },
          loading: false,
          success: (res) => {
            this.accountScrollLoading = false
            if (res.code === 0) {
              const payload = res.data || {}
              const remoteList = payload.content || []
              this.accountScrollPage = nextPage
              this.accountScrollHasMore = !!payload.hasMore
              
              const mergedMap = {}
              const mergedList = []
              this.accountList.concat(remoteList).forEach((item) => {
                if (!item) return
                const advertiserId = item.advertiserId !== undefined && item.advertiserId !== null
                  ? String(item.advertiserId)
                  : ''
                if (!advertiserId || mergedMap[advertiserId]) return
                mergedMap[advertiserId] = true
                mergedList.push(item)
              })
              this.accountList = mergedList
            }
          },
          error: () => {
            this.accountScrollLoading = false
          }
        })
      }
    },
    gotoEdit(item) {
      // console.log(item)
      const data = JSON.parse(JSON.stringify(item));
      data.roomInfo = JSON.stringify(data.roomInfo);
      data.productInfo = JSON.stringify(data.productInfo);
      data.selectedCreatives = JSON.stringify(data.selectedCreatives || []);
      data.deliveryMode = data.deliveryMode || 'COST';
      data.materialMode = data.materialMode || 'AUTO';
      if (data.AllBudget) {
        data.scheduleType = data.AllBudget.scheduleType !== false;
        data.startTime = data.AllBudget.startTime || '';
        data.endTime = data.AllBudget.endTime || '';
      }
      // console.log(data)
      this.$router.push({
        path: '/qdd/admin/UniPromotionNew.html',
        query: data
      })
    },
    switchChange(type, index, adId) {
      console.log(type, index)
      // this.tableData[index].switchStatus = e
      // this.$set(this.tableData[index], 'switchStatus', e)
      let adIds = [adId]
      let data = { adId: adIds, optStatus: type, advertiserId: this.advertiserId }
      console.log(data, 'data=====')
      this.$axios.post({
        url: '/uniPromotion/updateAdStatus',
        data,
        confirm: type == 2 ? '确定删除该全域计划？' : '',
        success: (data) => {
          console.log(data, '2222')
          if (data.code == 0) {
            // this.$message.success('删除成功')
            if (!type) {
              this.$message.success('暂停成功')
            } else if (type == 1) {
              this.$message.success('启用成功')
            } else if (type == 2) {
              this.$message.success('删除成功')
            }

            setTimeout(() => {
              console.log('switchChange')
              this.getData()
            }, 100)
          } else {
            this.$message.error(data.msg || '出错了')
          }
        }
      });
    },
    parseJsonSafely(jsonString) {
      return JSON.parse(jsonString, (key, value) => {
        // 识别需要保持精度的字段
        if (key === 'productId' && typeof value === 'number' &&
          value > Number.MAX_SAFE_INTEGER) {
          return value.toString(); // 转换为字符串
        }
        return value;
      });
    },
    showSelectPopup(index, type, isExist) {
      this.selectedDYNumber = null
      this.searchAccount = null
      this.searchAccountList = []
      this.searchAccountRequestId += 1
      if (this.searchAccountTimer) {
        clearTimeout(this.searchAccountTimer)
      }
      this.searchAccountScrollPage = 1
      this.searchAccountScrollHasMore = true
      this.searchAccountScrollLoading = false
      console.log(index)
      if (!type) {
        this.showNumberPopup = null
        this.showTargetPopup = null
        this.showAllTargetPopup = null
        if (this.route_params.advertiserName) return
        if (this.showPopup == index) {
          this.showPopup = null
        } else {
          this.showPopup = index
        }
      } else if (type == 1) {
        this.showPopup = null
        this.showTargetPopup = null
        this.showAllTargetPopup = null
        if (this.route_params.advertiserName) return
        if (this.showNumberPopup == index) {
          this.showNumberPopup = null
        } else {
          if (isExist) {
            this.showNumberPopup = index
          }
        }
      } else if (type == 2) {
        this.noRoiTarget = false
        this.nodayBudget = false
        if (isExist) {
          this.roiTarget = this.tableData[index].AllBudget.roiTarget
          this.dayBudget = this.tableData[index].AllBudget.dayBudget
        } else {
          this.roiTarget = ''
          this.dayBudget = ''
        }
        this.showPopup = null
        this.showNumberPopup = null
        this.showAllTargetPopup = null
        if (this.showTargetPopup == index) {
          this.showTargetPopup = null
        } else {
          this.showTargetPopup = index
        }
      } else if (type == 3) {
        this.showPopup = null
        this.showTargetPopup = null
        this.showNumberPopup = null
        this.noRoiTarget = false
        this.nodayBudget = false
        this.roiTarget = ''
        this.dayBudget = ''
        if (this.showAllTargetPopup) {
          this.showAllTargetPopup = false
        } else {
          this.showAllTargetPopup = true

        }
        console.log(this.showAllTargetPopup)
      }
    },
    goSelectAccount(index, item) {
      this.showPopup = null
      let data = {
        name: item.name,
        id: item.advertiserId
      }
      this.$set(this.tableData[index], 'account', data)
      this.$set(this.tableData[index], 'selectedDYNumber', null)
      this.$set(this.tableData[index], 'dyNumberList', [])
      this.$set(this.tableData[index], 'selectedList', [])
      this.$emit('selectChange')
      this.getDYNumberList(item.advertiserId, index)
    },
    getDYNumberList(id, index, type) {
      this.$axios.get({
        url: '/oceanEngineAdvertiser/getAllInfoAndDouYin/' + id,
        success: (res) => {
          console.log(res, '222')
          if (res.code === 0) {
            this.$set(this.tableData[index], 'dyNumberList', res.data || [])
            if (type) {
              let selectDYNumber_data = this.tableData[0].selectedDYNumber
              let index = res.data.findIndex((obj) => {
                return obj.awemeShowId == selectDYNumber_data.id
              })
              selectDYNumber_data.id = res.data[index].id
              this.$set(this.tableData[0], 'selectedDYNumber', selectDYNumber_data)
            }
          } else {
            this.$message.error(res.msg || '获取数据错误')
          }
        },
        error: () => {
          this.$message.error('出错了')
        },
      })

    },
    goSelectDYNumber(index2, index) {
      this.selectedDYNumber = index2
      this.showNumberPopup = null
      if (this.searchDYNumber) {
        this.$set(this.tableData[index], 'selectedDYNumber', this.searchDYNumberList[index2])
      } else {
        this.$set(this.tableData[index], 'selectedDYNumber', this.tableData[index].dyNumberList[index2])
      }

      this.$set(this.tableData[index], 'selectedList', [])
      this.$emit('selectChange')
    },
    inputSearchDYNumber(index) {
      this.selectedDYNumber = null
      this.searchDYNumberList = []
      this.tableData[index].dyNumberList.forEach((obj) => {
        console.log(obj, obj.id)
        if (obj.name.includes(this.searchDYNumber) || JSON.stringify(obj.id).includes(this.searchDYNumber)) {
          this.searchDYNumberList.push(obj)
        }
      })
    },
    confirmBudget(index, type) {
      if (!this.roiTarget) {
        this.noRoiTarget = true
        return
      } else {
        if (this.roiTarget < 0.01 || this.roiTarget > 10000) {
          this.noRoiTarget = true
          return
        } else {
          this.noRoiTarget = false
        }
      }
      if (!this.dayBudget) {
        this.nodayBudget = true
        return
      } else {
        if (this.dayBudget < 300 || this.dayBudget > 999999999.99) {
          this.nodayBudget = true
          return
        } else {
          this.nodayBudget = false

        }
      }
      let data = {
        roiTarget: this.roiTarget,
        dayBudget: this.dayBudget
      }
      if (type) {
        this.$set(this.tableData[index], 'AllBudget', data)
      } else {
        if (this.choosedBudgetType) {
          this.tableData.forEach((obj) => {
            this.$set(obj, 'AllBudget', data)
          })
        } else {
          this.tableData.forEach((obj) => {
            if (!obj.AllBudget) {
              this.$set(obj, 'AllBudget', data)
            }
          })

        }

      }
      this.showTargetPopup = null
      this.showAllTargetPopup = null
    },
    inputBlur(type) {
      if (type) {
        if (!this.dayBudget) {
          this.nodayBudget = true
          return
        } else {
          this.inputBudget()
        }
      } else {
        if (!this.roiTarget) {
          this.noRoiTarget = true
          return
        } else {
          this.inputRoiTarget()
        }
      }
    },
    inputBudget() {
      if (!this.dayBudget) return
      if (this.dayBudget < 300 || this.dayBudget > 999999999.99) {
        this.nodayBudget = true
      } else {
        this.nodayBudget = false
      }
    },
    inputRoiTarget() {
      if (!this.roiTarget) return
      if (this.roiTarget < 0.01 || this.roiTarget > 10000) {
        this.noRoiTarget = true
      } else {
        this.noRoiTarget = false
      }
    },
    batchsetBudget() {
      this.tableData.forEach(() => {
        console.log('1')
      })
    },
    getMoreData() {
      if (!this.page.hasMore) return
      this.pageIndex++
      console.log('getMoreData')
      this.getData(true, true)
    },
    getSelectedCreativeCount(row) {
      if (!row || !Array.isArray(row.selectedCreatives)) {
        return 0
      }
      return row.selectedCreatives.filter((item) => item && item.productId && item.selectedVideoId).length
    },
    getUniPromotionMaterialLabel(row) {
      return row && row.materialMode === 'MANUAL' ? '自选素材' : '自动素材'
    },
    openPromotionConfig(scope, index) {
      if ((scope.row.account && scope.row.selectedDYNumber)
        || (scope.row.account && (scope.row.dyNumberList ? !scope.row.dyNumberList.length : !scope.row.dyNumberList))) {
        this.$emit('openPromotionConfig', { scope, index })
        return
      }
      this.$message.warning('请先选择抖音号')
    },
    selectProduct(scope, index, type) {
      if ((scope.row.account && scope.row.selectedDYNumber) || (scope.row.account && (scope.row.dyNumberList ? !scope.row.dyNumberList.length : !scope.row.dyNumberList))) {
        this.$emit('selectProduct', { scope, index, type })
      }
    },
    selectChange(e, select2) {
      console.log(e, select2)
      if (select2) {
        console.log(e, 'selectChangegetAllInfoAndDouYin')
        this.getSearchSelectData(e)
      }
    },
    getRandomTwoDigitNumber() {
      const randomNumber = Math.floor(Math.random() * 90) + 10;
      return randomNumber;
    },
    getRandomCharacter(characters) {
      return characters[Math.floor(Math.random() * characters.length)];
    },
    getRandomString(length, charSets) {
      let result = '';
      for (let i = 0; i < length; i++) {
        const randomCharSet = charSets[Math.floor(Math.random() * charSets.length)];
        result += this.getRandomCharacter(randomCharSet);
      }
      return result;
    },
    formatTime(timestamp) {
      if (!timestamp) return '-';
      if (typeof timestamp === 'string' && timestamp.includes('-')) return timestamp;
      const date = new Date(Number(timestamp));
      if (isNaN(date.getTime())) return timestamp;
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      const h = String(date.getHours()).padStart(2, '0');
      const min = String(date.getMinutes()).padStart(2, '0');
      const s = String(date.getSeconds()).padStart(2, '0');
      return `${y}-${m}-${d} ${h}:${min}:${s}`;
    },
    generateRandomString() {
      const upperCaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      const lowerCaseLetters = 'abcdefghijklmnopqrstuvwxyz';
      const digits = '1234567890';
      const charSets = [upperCaseLetters, lowerCaseLetters, digits];
      return this.getRandomString(12, charSets);
    },
    uploadVideo(option, row) {
      const currentTime = new Date();
      const year = currentTime.getFullYear();
      const month = String(currentTime.getMonth() + 1).padStart(2, '0');
      const day = String(currentTime.getDate()).padStart(2, '0');
      const datePath = `videos/edit/${year}${month}${day}`;
      const timestamp = currentTime.getTime();
      const name = timestamp + this.generateRandomString() + '.mp4';

      // 组合完整的OSS对象键（包含路径）
      const objectKey = `${datePath}/${name}`;

      const client = new OSS({
        accessKeyId: "LTAI5tEEuTUn9UQMRW2TqNwF",
        accessKeySecret: "sjujH7JdyAgK8gsb2e79xOrRdTa2XK",
        bucket: "ceshioss0012",
        endpoint: 'https://oss-cn-beijing.aliyuncs.com/'
      });

      try {
        client.multipartUpload(
          objectKey,
          option,
          {
            progress: (p) => {
              console.log(p);
            },
            parallel: 4,
            partSize: 1024 * 1024 * 100,
            headers: {
              'content-type': 'video/mp4'
            },
            timeout: 60000000,
          }
        ).then((res) => {
          console.log(res, '111222333');
          const value = JSON.parse(JSON.stringify(row));

          // 修改点：使用CDN域名替换OSS原始域名
          const cdnBaseUrl = 'https://cdn.doumaomao.cn/';
          const fileUrl = `${cdnBaseUrl}${objectKey}`;

          value.path = fileUrl;  // 使用新的CDN URL
          value.status = 3;
          console.log({
            id: row.id,
            newVideoPath: fileUrl
          })

          if (this.pageName == "topTrendingVideos") {
            this.$axios.post({
              url: '/topTrendingVideos/upload/newVideoPath',
              data: {
                id: row.id,
                newVideoPath: fileUrl
              },
              success: (data) => {
                if (data.code === 0) {
                  this.$message.success('文件上传成功');
                  this.$emit('vieoUpdate', value);
                } else {
                  this.$message.error(data.msg ? data.msg : '文件上传失败');
                }
              },
            });
          } else {
            this.$axios.post({
              url: '/douYinRelease/update',
              data: value,
              success: (data) => {
                if (data.code === 0) {
                  this.$message.success('文件上传成功');
                  this.$emit('vieoUpdate', value);
                } else {
                  this.$message.error(data.msg ? data.msg : '文件上传失败');
                }
              },
            });
          }

        });
      } catch (e) {
        console.log(e);
      }
      return false;
    },
    async handleSortChange({ prop, order }) {
      this.order = order
      this.sort = prop
      console.log(prop, order, 123123)
      this.$set(this.page, 'cursor', 0)
      this.getData(true)
    },
    showImage(imageSrc) {
      this.selectedImage = imageSrc;
      console.log(this.selectedImage, 1111111111)
      this.dialogVisible = true;
    },
    handleSpeak(text) {
      msg.text = text // 内容
      msg.lang = 'zh-CN' // 使用的语言:中文
      msg.volume = 1 // 声音音量：1
      msg.rate = 1 // 语速：1
      msg.pitch = 1 // 音高：1
      synth.speak(msg) // 播放
    },
    handleUploadImage(event, insertImage, files) {
      const file = files[0]
      const isLt10M = file.size / 1024 / 1024 < 5
      if (!isLt10M) {
        this.$message.error('上传图片大小不能超过5MB!')
        return
      }
      let params = new FormData()
      params.append('file', file)
      const loading = this.$loading({
        fullscreen: true,
      })
      axios
        .create({
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .post('/upload/image', params)
        .then((res) => {
          const data = res.data
          if (data.code === 10000) {
            insertImage({
              url: data.data,
              desc: '',
              width: 'auto',
              height: 'auto',
            })
          } else {
            this.$message.error(data.msg || '上传图片错误')
          }
        })
        .catch((error) => {
          console.log(error)
        })
      loading.close()
    },

    /**
     * 获取验证码
     * @param url
     */
    getCode(url, second) {
      if (!second) second = 60
      this.codeName = second + 's后获取'
      this.btnCodeDisabled = true
      this.$axios.get({
        url: url,
        data: {},
      })
      this.getCodeSeconds(second)
    },
    getCodeSeconds(second) {
      setTimeout(() => {
        if (second > 1) {
          this.codeName = second - 1 + 's后获取'
          this.getCodeSeconds(second - 1)
        } else {
          this.btnCodeDisabled = false
          this.codeName = '获取验证码'
        }
      }, 1000)
    },

    // 是否拥有权限
    havePermission(perm) {
      const perms = this.permissions
      if (!perms || perms.length <= 0) {
        return false
      }
      return perms.indexOf(perm) !== -1
    },
    editorAddData(data) {
      this.addForm.content = data
    },
    editorUpdateData(data) {
      this.updateForm.content = data
    },
    lineFeed(data) {
      return data.replace(/\n/g, '<br>')
    },
    getDateFunction() {
      this.$set(this.page, 'cursor', 0)
      return this.getData(true)
    },
    changePageIndexTogetDate() {
      this.pageIndex = 1
      this.$set(this.page, 'current', 1)
      this.getData()
    },

    // 获取用户权限数据
    getUserPermissions() {
      this.$axios.get({
        url: '/permission/getUserPermissions',
        data: {},
        success: (res) => {
          if (res.code === 0) {
            this.permissions = res.data
            // console.log(this.permissions);
            //console.log(this.permission);
            if (this.permission) {
              if (this.permission.add) {
                this.addPermission =
                  this.permissions.indexOf(this.permission.add) !== -1
              }
              if (this.permission.update) {
                this.updatePermission =
                  this.permissions.indexOf(this.permission.update) !== -1
              }
              if (this.permission.delete) {
                this.deletePermission =
                  this.permissions.indexOf(this.permission.delete) !== -1
              }
              if (this.permission.deleteBatch) {
                this.deleteBatchPermission =
                  this.permissions.indexOf(this.permission.deleteBatch) !== -1
                // console.log(this.deleteBatchPermission, ' this.deleteBatchPermission')
              }
            }
            //console.log(this.addPermission,this.updatePermission,this.deletePermission,this.deleteBatchPermission)
          } else {
            this.$message.error(res.msg || '获取数据错误')
          }
        },
        error: () => {
          this.$message.error('出错了')
        },
      })
    },
    //获取select列表框数据
    getSelectData() {
      this.selectFields.forEach((field, index) => {
        let type = 'post'
        if (field.isGet) {
          type = 'get'
          type = 'get'
        }

        if (field.selectUrl) {
          const reqData = field.selectUrl.includes('optionsByCondition')
            ? { pageIndex: 1, pageSize: 30 }
            : undefined
          this.$axios[type]({
            url: field.selectUrl,
            data: reqData,
            success: (res) => {
              if (res.code === 0) {
                const objs = this.getSelectResponseList(res.data)
                let options = this.buildLegacySelectOptions(field, objs)
                console.log(options, 'options', field)
                this.selectFields[index].selectData = options
              } else {
                this.$message.error(res.msg || '获取数据错误')
              }
            },
            error: () => {
              this.$message.error('出错了')
            },
          })
        }
      })
    },
    //获取select列表框数据
    getTableSelectData() {
      //console.log("getTableSelectData");
      console.log(this.tableSelectFields, '55555555');
      this.tableSelectFields.forEach((field, index) => {
        if (field.selectUrl) {
          const reqData = field.selectUrl.includes('optionsByCondition')
            ? { pageIndex: 1, pageSize: 30 }
            : undefined
          this.$axios.post({
            url: field.selectUrl,
            data: reqData,
            success: (res) => {
              console.log(res, '111111111')
              if (res.code === 0) {
                const objs = this.getSelectResponseList(res.data)
                let options = this.buildLegacySelectOptions(field, objs)
                this.tableSelectFields[index].selectData = options
              } else {
                this.$message.error(res.msg || '获取数据错误')
              }
            },
            error: () => {
              this.$message.error('出错了')
            },
          })
        }
      })
      //console.log(this.tableSelectFields);
    },
    //获取select列表框数据
    getSearchSelectData(isChange,) {

      this.searchSelectFields &&
        this.searchSelectFields.forEach((field, index) => {
          if (field.selectUrl) {
            if (this.isRemoteSearchField(field)) {
              this.fetchRemoteSearchOptions(field, {
                keyword: '',
                pageIndex: 1,
                append: false,
              })
              return
            }
            if (field.select3) {
              if (isChange) {
                this.$axios.get({
                  url: field.selectUrl + '/' + isChange,
                  success: (res) => {
                    console.log(res, '222')
                    if (res.code === 0) {
                      const objs = res.data
                      let options = this.buildSearchSelectOptions(field, objs)
                      this.$set(this.searchSelectFields[index], 'selectValue', options)


                    } else {
                      this.$message.error(res.msg || '获取数据错误')
                    }
                  },
                  error: () => {
                    this.$message.error('出错了')
                  },
                })

              }

            } else {
              let type = 'post'
              if (field.isGet) {
                type = 'get'
              }
              this.$axios[type]({
                url: field.selectUrl,
                success: (res) => {
                  console.log(res)
                  if (res.code === 0) {
                    const objs = res.data.content ? res.data.content : res.data
                    let options = this.buildSearchSelectOptions(field, objs)
                    // console.log(options, 'options')
                    // this.searchSelectFields[index].selectValue = options
                    this.$set(this.searchSelectFields[index], 'selectValue', options)
                    // console.log(this.searchSelectFields, 'this.searchSelectFields')
                    // console.log(index, this.pageName == 'intelligentRegulation', this.pageName)
                    if (index == 1) {
                      if (this.pageName == 'intelligentRegulation' || this.pageName == 'ShutDownDueToOverallLosses' || this.pageName == 'contacts' || this.pageName == 'BalanceManage' || this.pageName == 'BudgetManage' || this.pageName == 'intelligentAutoRebuildManage') {

                        if (this.tableData.length) {
                          console.log('createPerson1')
                          this.tableData.forEach((dataObj) => {
                            let userIndex = options.findIndex((ind) => ind.key == (dataObj.userId || dataObj.agentId))
                            if (userIndex !== -1) {
                              this.$set(dataObj, 'createPerson', options[userIndex].value)
                            }
                          })
                        }
                        // console.log(this.tableData, '555555')
                      }

                    }
                  } else {
                    this.$message.error(res.msg || '获取数据错误')
                  }
                },
                error: () => {
                  this.$message.error('出错了')
                },
              })
            }

          }
        })
    },
    //获取表格数据
    async getData() {
      // console.log('getDatagetDatagetDatagetDatagetData')
      // const loading = this.$loading({
      //   fullscreen: true,
      // })
      // console.log(loading3, 'loading3open')
      loading3.show()
      // console.log(loading, 123123)
      let type = 'get'
      const condition = JSON.parse(JSON.stringify(this.query))

      if (this.pageName == 'SmartRoiRuleLogs') {
        type = 'post'
      }

      if (this.pageName == 'UniPromotion') {
        if (Number(this.advertiserId) === 0) {
          this.$message.warning('请先选择具体店铺，或切换到全部（今日创建）后再查询')
          return
        }
        type = 'post'
        this.loading2 = true
        condition.advertiserId = this.advertiserId
        condition.smart_bid_type = this.activeType ? 'SMART_BID_CONSERVATIVE' : 'SMART_BID_CUSTOM'
        if (this.selectedPlanStatus) {
          condition.status = this.selectedPlanStatus
        }
        if (this.selectStartData) {
          condition.create_start_date = this.selectStartData
        }
        if (this.selectEndData) {
          condition.create_end_date = this.selectEndData
        }
        if (this.selectedConsumeStatus) {
          condition.having_cost = this.selectedConsumeStatus
        }
        console.log(this.searchPlanKeyWord)
        if (this.searchPlanKeyWord) {
          console.log('112')
          condition.search_keyword = this.searchPlanKeyWord
          condition.search_keyword_type = this.selectedSearchPlanStatus
        }
      }
      if (this.order !== undefined && this.order !== null) {
        console.log(this.pageName)
        if (this.pageName == 'UniPromotion') {
          let order = this.order === 'descending' ? 'DESC' : 'ASC'
          condition.order = order
          switch (this.sort) {
            case 'statCost':
              condition.order_field = 'stat_cost'
              break;
            case 'totalPrepayAndPayOrderRoi2':
              condition.order_field = 'total_prepay_and_pay_order_roi2'
              break;
            case 'totalPayOrderGmvForRoi2':
              condition.order_field = 'total_pay_order_gmv_for_roi2'
              break;
            case 'totalPayOrderCountForRoi2':
              condition.order_field = 'total_pay_order_count_for_roi2'
              break;
            case 'totalCostPerPayOrderForRoi2':
              condition.order_field = 'total_cost_per_pay_order_for_roi2'
              break;
          }
        } else {
          let order = this.order === 'descending' ? 'desc' : 'asc'
          condition.order = order
          condition.sort = this.sort
        }
      } else {
        condition.order = null
        condition.sort = null
      }
      if (this.pageName == 'QianchuanScheduleTask' || this.pageName == 'QianchuanMultiProductScheduleTask') {
        type = 'post'
        if (this.pageName == 'QianchuanScheduleTask') {
          condition.productTaskType = 1
        } else {
          condition.productTaskType = 2

        }
      }
      // condition.pageIndex = this.page.current
      if (!this.loadingMore) {
        condition.pageIndex = this.page.current
        condition.pageSize = this.page.size
      }
      condition.cursor = this.page.cursor || 0
      if (this.pageIndex == 1) {
        condition.cursor = 0
      }
      console.log(condition, type, 'condition')
      if (!this.url.get) return
      if (typeof this.beforeGetData === 'function') {
        try {
          const shouldContinue = await this.beforeGetData(condition)
          if (shouldContinue === false) {
            this.loading2 = false
            loading3.close()
            return
          }
        } catch (error) {
          console.error('beforeGetData failed:', error)
          this.loading2 = false
          loading3.close()
          return
        }
      }
      let path = ''
      if (this.pageName == 'ShutDownDueToOverallLosses' || this.pageName == 'intelligentRegulation' || this.pageName == 'budgetRegulation' || this.pageName == 'BalanceManage' || this.pageName == 'BudgetManage' || this.pageName == 'contacts' || this.pageName == 'intelligentAutoRebuildManage') {
        path = (condition.monitorStatus !== '' && condition.monitorStatus !== undefined ? '&status=' + condition.monitorStatus : '') + (condition.createPerson !== '' && condition.createPerson !== undefined ? '&userId=' + condition.createPerson : '')
          + (condition.ruleName !== '' && condition.ruleName !== undefined ? '&ruleName=' + condition.ruleName : '') + (this.url.get.includes('?') ? '&' : '?') + 'pageIndex=' + this.page.current + '&pageSize=' + this.page.size
        console.log(path, '-----', this.url.get)
      }
      console.log(this.url.get + path, 'path---------------')
      this.$axios[type]({
        url: this.url.get + path,
        data: condition,
        loading: false,
        success: (res) => {
          console.log(res, 'getData---------');
          if (this.url.get == '/withdrawal/listByCondition') {
            // console.log(res)
            if (this.totalElements !== res.data.totalElements) {
              if (this.totalElements) {
                //  播放音乐
                let num = res.data.totalElements - this.totalElements
                if (this.play) {
                  console.log('Bofang', num)
                  this.handleSpeak(`您有${num}条新提现订单`)
                }
              }
              this.totalElements = res.data.totalElements
            }
          }
          if (res.code === 0) {
            this.getDataNum = 0
            this.isNoData = false
            this.loading2 = false

            loading3.close();
            console.log('loading3close')
            const data = res.data

            if (data.content !== undefined) {
              if (data.content.length < 0) {
                return
              }
              if (this.loadingMore && this.pageIndex !== 1) {
                let dataArr =
                  this.formFields.toTree === false
                    ? data.content
                    : this.$toTree.toTree(data.content)
                this.tableData = [...this.tableData, ...dataArr]
              } else {
                this.tableData =
                  this.formFields.toTree === false
                    ? data.content
                    : this.$toTree.toTree(data.content)
              }

              if (res.cursor) {
                this.page.cursor = res.cursor
              }
              if (res.hasMore) {
                this.page.hasMore = res.hasMore
              } else {
                // console.log(res.data.totalPages > this.pageIndex, res.data.totalPages, this.pageIndex, '22222222')
                this.page.hasMore = res.data.totalPages > this.pageIndex
              }
              this.page.current = data.pageable.pageNumber + 1
              this.page.size = data.pageable.pageSize
              this.page.totalSize = data.totalElements
              this.page.totalPages = data.totalPages
              this.page.realSize = data.content.length
              this.page.sizes = []
              for (let i = 1; i <= Math.ceil(this.page.totalSize / 10); i++) {
                this.page.sizes.push(i * 10)
                if (i === 10) {
                  break
                }
              }
            } else {
              if (this.loadingMore && this.page.cursor && this.pageIndex !== 1) {

                this.tableData = [...this.tableData, ...data]
              } else {
                this.tableData = data
              }
              if (res.cursor) {
                this.page.cursor = res.cursor
              }
              if (res.hasMore) {
                this.page.hasMore = res.hasMore
              } else {
                // console.log(res.data.totalPages > this.pageIndex, res.data.totalPages, this.pageIndex, '22222222')
                this.page.hasMore = res.data.totalPages > this.pageIndex
              }
              this.page.totalSize = data.length
              this.page.totalPages = 1
              this.page.realSize = data.length
              this.page.sizes = [data.length]
            }
            this.decorateOceanEngineAdvertiserRows()
            if (this.pageName == 'topTrendingVideos') {
              this.tableData.forEach((row) => {
                if (!row) {
                  return
                }
                if (row.clipMode === null || row.clipMode === undefined || row.clipMode === '') {
                  this.$set(row, 'clipMode', 0)
                }
              })
            }
            this.$emit('data-loaded', {
              rows: this.tableData,
              page: { ...this.page },
              rawData: data,
            })
            this.syncTableLayout()
            if (this.url.get == '/uniPromotion/listByCondition') {
              this.page.sizes = [10, 20, 50, 100]
            }
            if (this.pageName == 'UniPromotion') {
              this.tableData.forEach((obj) => {
                try {
                  if (typeof obj.roomInfo === 'string') obj.roomInfo = JSON.parse(obj.roomInfo)
                  if (typeof obj.productInfo === 'string') obj.productInfo = JSON.parse(obj.productInfo)
                  if (typeof obj.compensateInfo === 'string') obj.compensateInfo = JSON.parse(obj.compensateInfo)
                } catch (e) {
                  console.error('UniPromotion JSON parse error:', e, obj)
                }
                obj.status2 = this.statusName(obj.status)
                if (obj.status == 'DELIVERY_OK') {
                  obj.switchStatus = true
                }
              })
              this.checkBatchSuggestion()
            }
            if (this.pageName == 'SmartRoiRuleLogs') {
              this.tableData.forEach((obj) => {
                if (obj.reportDesc) {
                  obj.reportDesc = JSON.parse(obj.reportDesc)

                }
              })
            }

            if (this.pageName == 'ShutDownDueToOverallLosses') {
              this.tableData.forEach((obj) => {
                if (!obj.executeContent) return
                obj.ruleInfo = obj.executeContent.rangeValue + '内，消耗>' + (Number.isInteger(JSON.parse(obj.executeContent.maxConsume)) ? JSON.parse(obj.executeContent.maxConsume).toFixed(1) : JSON.parse(obj.executeContent.maxConsume))
                obj.executeContent.conditionList.forEach((condition) => {
                  obj.ruleInfo = obj.ruleInfo + '且' + condition.ordersValue + (condition.compareValue == '小于等于' ? '<=' : '>') + (condition.consumeMoney ? JSON.parse(condition.consumeMoney).toFixed(1) : 0.0)
                })
                obj.ruleInfo = obj.ruleInfo + '关停'
                if (obj.executeContent.monitorToOpen) {
                  obj.ruleInfo = obj.ruleInfo + '，关停后持续监控' + obj.executeContent.monitorToOpen + '分钟，'
                  obj.executeContent.conditionList.forEach((condition, ind) => {
                    if (ind) {
                      obj.ruleInfo = obj.ruleInfo + '或'
                    }
                    obj.ruleInfo = obj.ruleInfo + condition.ordersValue + (condition.compareValue == '小于等于' ? '>' : '<=') + (condition.consumeMoney ? JSON.parse(condition.consumeMoney).toFixed(1) : 0.0)
                  })
                  obj.ruleInfo = obj.ruleInfo + '自动开启'
                }
                obj.executionMethod = obj.executeContent.executeValue
                obj.executeAction = obj.executeContent.noticeValue

              })
            } else if (this.pageName == 'intelligentRegulation') {

              this.tableData.forEach((obj) => {
                let selectData = obj.executeContent
                // console.log(selectData, 'selectData')
                obj.ruleInfo = ''
                if (selectData && selectData.durationValue) {
                  let consumeMin = (Number.isInteger(JSON.parse(selectData.consumeMin)) ? JSON.parse(selectData.consumeMin).toFixed(1) : JSON.parse(selectData.consumeMin))
                  let wholePayNum = (Number.isInteger(JSON.parse(selectData.wholePayNum)) ? JSON.parse(selectData.wholePayNum).toFixed(1) : JSON.parse(selectData.wholePayNum))
                  let roiImproveNum = (Number.isInteger(JSON.parse(selectData.roiImproveNum)) ? JSON.parse(selectData.roiImproveNum).toFixed(1) : JSON.parse(selectData.roiImproveNum))
                  obj.ruleInfo = '实时监控' + (selectData.durationValue == '当前时段' ? '当前时段' : selectData.durationValue + '在后台' + selectData.judgeValue) + '跑量情况，若整体消耗>' + consumeMin + '：' + selectData.wholePayValue + '≤' + wholePayNum + '时,整体roi目标提升' + roiImproveNum + (selectData.improveValue == '提高' ? '' : '%') + ';'
                  selectData.stairsList.forEach((condition) => {
                    let minValue = (Number.isInteger(JSON.parse(condition.minValue)) ? JSON.parse(condition.minValue).toFixed(1) : JSON.parse(condition.minValue))
                    let wholePayNum = (Number.isInteger(JSON.parse(condition.wholePayNum)) ? JSON.parse(condition.wholePayNum).toFixed(1) : JSON.parse(condition.wholePayNum))
                    let roiImproveNum = (Number.isInteger(JSON.parse(condition.roiImproveNum)) ? JSON.parse(condition.roiImproveNum).toFixed(1) : JSON.parse(condition.roiImproveNum))
                    // console.log(roiImproveNum, 'roiImproveNum-----')
                    obj.ruleInfo = obj.ruleInfo + minValue + '<' + condition.wholePayType + '<=' + wholePayNum + '时,整体roi目标提升' + roiImproveNum + (condition.improveValue == '提高' ? '' : '%') + ';'

                  })
                  let roiTargetMax = (Number.isInteger(JSON.parse(selectData.roiTargetMax)) ? JSON.parse(selectData.roiTargetMax).toFixed(1) : JSON.parse(selectData.roiTargetMax))
                  obj.ruleInfo = obj.ruleInfo + '整体roi目标最高调整至' + roiTargetMax
                }
                // console.log(obj.ruleInfo)

                if (selectData && selectData.consumeMax) {
                  let consumeMax = (Number.isInteger(JSON.parse(selectData.consumeMax)) ? JSON.parse(selectData.consumeMax).toFixed(1) : JSON.parse(selectData.consumeMax))
                  let wholePayNum2
                  let wholePayNum3 = (Number.isInteger(JSON.parse(selectData.wholePayNum3)) ? JSON.parse(selectData.wholePayNum3).toFixed(1) : JSON.parse(selectData.wholePayNum3))
                  if (selectData.durationValue) {
                    obj.ruleInfo = obj.ruleInfo + '，'
                  }
                  obj.ruleInfo = obj.ruleInfo + '每小时判断上一时段跑量情况，若整体消耗≤' + consumeMax + '：'
                  if (selectData.wholePayNum2 !== '') {
                    wholePayNum2 = (Number.isInteger(Number(selectData.wholePayNum2))) ? Number(selectData.wholePayNum2).toFixed(1) : Number(selectData.wholePayNum2)
                    obj.ruleInfo = obj.ruleInfo + selectData.wholePayValue2 + '>' + wholePayNum2 + '时,'

                  }
                  let roiTargetMin = (Number.isInteger(JSON.parse(selectData.roiTargetMin)) ? JSON.parse(selectData.roiTargetMin).toFixed(1) : JSON.parse(selectData.roiTargetMin))
                  obj.ruleInfo = obj.ruleInfo + '整体ROI目标降低' + wholePayNum3 + (selectData.reduceValue == '降低' ? '' : '%') + ';整体ROI目标最低调整至' + roiTargetMin
                }
                obj.executionMethod = obj.executeContent && obj.executeContent.executeValue
                obj.executeAction = obj.executeContent && obj.executeContent.noticeValue
              })
            } else if (this.pageName == 'BalanceManage') {
              this.tableData.forEach((obj) => {
                let selectData = obj.executeContent
                // console.log(selectData, 'selectData')
                if (selectData && selectData.balanceMin) {
                  obj.ruleInfo = '账户余额≤' + selectData.balanceMin + '元'
                }
                obj.executeAction = '仅通知'
                obj.executionMethod = obj.executeContent.executeValue

              })
            } else if (this.pageName == 'BudgetManage') {
              this.tableData.forEach((obj) => {
                let selectData = obj.executeContent
                // console.log(selectData, 'selectData')
                if (selectData && selectData.balanceMin) {
                  obj.ruleInfo = '所监控计划当日消耗达到日预算的' + selectData.balanceMin + '%'
                }
                obj.executeAction = '仅通知'
                obj.executionMethod = obj.executeContent.executeValue


              })
            } else if (this.pageName == 'intelligentAutoRebuildManage') {

              this.tableData.forEach((obj) => {
                let selectData = obj.executeContent
                obj.ruleInfo = ''
                if (selectData && selectData.noOrderContinuousDays) {
                  obj.ruleInfo = obj.ruleInfo + '计划保持持续开启状态下,最近连续' + selectData.noOrderContinuousDays + '天,累计整体成交订单数<=' + JSON.parse(selectData.noOrderTotalOrders).toFixed(1) + ',删除计划并按照原参数重新搭建计划'

                  if (selectData.noOrderRebuildWithOriginalParams) {
                    obj.ruleInfo = obj.ruleInfo + ',在原参数基础上，整体ROI目标' + selectData.noOrderRoiAdjustType + JSON.parse(selectData.noOrderRoiTarget).toFixed(1) + (selectData.noOrderRoiAdjustType == '百分比降低' ? '%' : '')

                  }
                }

                if (selectData && selectData.noConsumeContinuousDays) {
                  obj.ruleInfo = obj.ruleInfo + '<br>计划保持持续开启状态下,最近连续' + selectData.noConsumeContinuousDays + '天,累计消耗<=' + JSON.parse(selectData.noConsumeTotalAmount).toFixed(1) + ',删除计划并按照原参数重新搭建计划'
                  if (selectData.noConsumeRebuildWithOriginalParams) {
                    obj.ruleInfo = obj.ruleInfo + ',在原参数基础上，整体ROI目标' + selectData.noConsumeRoiAdjustType + JSON.parse(selectData.noConsumeRoiTarget).toFixed(1) + (selectData.noConsumeRoiAdjustType == '百分比降低' ? '%' : '')
                  }
                }
                obj.ruleInfo = obj.ruleInfo + '<br>单账户每天最多重建' + selectData.maxDailyRebuildPerAccount + '条计划'
                obj.executionMethod = obj.executeContent && obj.executeContent.executeValue
                obj.executeAction = obj.executeContent && obj.executeContent.noticeValue
              })
            }
            if (this.pageName == 'intelligentRegulation' || this.pageName == 'ShutDownDueToOverallLosses' || this.pageName == 'contacts' || this.pageName == 'BalanceManage' || this.pageName == 'BudgetManage' || this.pageName == 'intelligentAutoRebuildManage') {

              let userArr = this.searchSelectFields[1].selectValue
              this.tableData.forEach((obj) => {
                // console.log('userArr', userArr)
                if (userArr && userArr.length) {
                  console.log('createPerson2')
                  let userIndex = userArr.findIndex((ind) => ind.key == (obj.userId || obj.agentId))
                  // console.log(userIndex, 'userIndex')
                  if (userIndex !== -1) {
                    this.$set(obj, 'createPerson', userArr[userIndex].value)
                  }
                }
              })
            }


            console.log(this.getData, 'getData---------');
          } else {
            if (this.pageName == 'UniPromotion' && res.msg == '请求频繁') {
              loading3.show()
              console.log('请求频繁请求频繁请求频繁请求频繁请求频繁请求频繁请求频繁请求频繁请求频繁请求频繁请求频繁请求频繁---------');
              if (this.getDataNum < 2) {
                setTimeout(() => {
                  this.getData()
                  this.getDataNum++
                }, 1000)
              } else {
                this.isNoData = true
                this.getDataNum = 0
                this.tableData = []
                this.loading2 = false
                loading3.close();
                // console.log('loading3close')
                this.$message.error(res.msg)
              }
            } else {

              this.isNoData = false
              this.loading2 = false
              loading3.close();
              // console.log('loading3close')
              this.$message.error(res.msg)

            }
          }
        },
        fail: () => {
          this.loading2 = false
          loading3.close();
          // console.log('loading3close')
        }
      })

    },
    // 前端页面直接发起的审核建议查询
    checkBatchSuggestion() {
      if (this.pageName !== 'UniPromotion') return;

      const requestList = this.tableData
        .filter(row => row.status2 === '投放中')
        .map(row => ({
          advertiserId: row.advertiserId,
          adId: row.adId
        }));

      console.log('checkBatchSuggestion started, requestList:', requestList);
      if (requestList.length === 0) return;

      this.$axios.post({
        url: '/uniPromotion/checkBatchSuggestion',
        data: { requestList },
        loading: false,
        success: (res) => {
          console.log('checkBatchSuggestion response:', res);
          if (res.code === 0 && res.data) {
            const suggestionMap = res.data;
            this.tableData.forEach(row => {
              // 强制转换为字符串匹配，防止 ID 精度或对象键类型不一致
              const adIdStr = String(row.adId);
              if (row.status2 === '投放中' && suggestionMap[adIdStr] && suggestionMap[adIdStr].list && suggestionMap[adIdStr].list.length > 0) {
                console.log(`Found suggestion for adId: ${adIdStr}`, suggestionMap[adIdStr]);
                this.$set(row, 'hasSuggestion', true);
                this.$set(row, 'suggestionData', suggestionMap[adIdStr].list);
              } else {
                this.$set(row, 'hasSuggestion', false);
              }
            });
          }
        }
      });
    },
    showSuggestionDialog(data) {
      this.$emit('show-suggestion', data);
    },
    //打开添加模态框
    open_add_dv() {
      this.addFormFields.forEach((item) => {
        if (item.default !== undefined) {
          this.$set(this.addForm, item.field, item.default)
        } else {
          this.$set(this.addForm, item.field, undefined)
        }
      })
      //this.getSelectData();
      this.addVisible = true
      if (this.pageName == 'QianchuanScheduleTask') {
        let index = this.formFields.model.findIndex((obj) => obj.field == 'startTime')
        console.log(index)
        if (index !== -1) {
          this.$set(this.formFields.model[index].rules[1], 'required', true)
        }
      }

      //console.log(this.$route.params.username)
      if (this.$route.params.username) {
        this.addForm.username = this.$route.params.username
      }
    },
    //添加模态框表单数据
    addFormData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 处理金额类型
          let submitAddForm = {}
          if (this.addForm) {
            for (let key in this.addForm) {
              let addFormField = this.addFormFields.filter((item) => {
                return item.field === key
              })
              if (
                addFormField &&
                addFormField.length > 0 &&
                addFormField[0]['type'] === 'money'
              ) {
                submitAddForm[key] = parseInt(
                  parseFloat(this.addForm[key]) * 100
                )
              } else {
                submitAddForm[key] = this.addForm[key]
              }
            }
          }

          if (this.pageName == 'QianchuanScheduleTask') {
            submitAddForm.status = 1
            submitAddForm.productTaskType = 1
            if (submitAddForm.enableBreakEvenRoiCheck) {
              submitAddForm.enableBreakEvenRoiCheck = 1
            } else {
              submitAddForm.enableBreakEvenRoiCheck = 0
            }
            if (submitAddForm.enableSuggestRoiThreshold) {
              submitAddForm.enableSuggestRoiThreshold = 1
            } else {
              submitAddForm.enableSuggestRoiThreshold = 0
            }
          } else if (this.pageName == 'QianchuanMultiProductScheduleTask') {
            submitAddForm.status = 1
            submitAddForm.productTaskType = 2
          }
          console.log('submitAddForm', submitAddForm)
          this.$axios.post({
            url: this.url.add,
            data: submitAddForm,
            confirm: '确定添加？',
            success: (res) => {
              if (res.code === 0) {
                this.$set(this.page, 'cursor', 0)
                console.log('addFormData')
                this.getData()
                this.$message.success('数据添加成功')
                this.addVisible = false
              } else {
                this.$message.error(res.msg ? res.msg : '数据添加失败')
              }
            },
            error: () => {
              this.$message.error('出错了')
            },
          })
        } else {
          return false
        }
      })
    },

    //打开编辑模态框
    openUpdateDV(row) {
      console.log(row, 'row')
      if (this.formFields && this.formFields.editFunc) {
        this.formFields.editFunc(row)
      }
      //this.getSelectData();
      if (row.parentId === 0) {
        row.parentId = null
      }
      this.updateForm = Object.assign({}, row)

      if (row) {
        for (let key in row) {
          let updateFormField = this.updateFormFields.filter((item) => {
            return item.field === key
          })

          if (
            updateFormField &&
            updateFormField.length > 0 &&
            updateFormField[0]['type'] === 'money'
          ) {
            this.updateForm[key] = parseFloat(row[key]) / 100
          } else {
            this.updateForm[key] = row[key]
          }
        }
        if (this.updateForm.enableBreakEvenRoiCheck === 1) {
          this.updateForm.enableBreakEvenRoiCheck = true
        } else {
          this.updateForm.enableBreakEvenRoiCheck = false
        }
        if (this.updateForm.enableSuggestRoiThreshold === 1) {
          this.updateForm.enableSuggestRoiThreshold = true
        } else {
          this.updateForm.enableSuggestRoiThreshold = false
        }
      }
      //this.updateForm = row;
      this.updateVisible = true
      setTimeout(() => {

        this.$refs.updateForm.clearValidate()
      }, 1)
      if (this.pageName == 'QianchuanScheduleTask') {
        let index = this.formFields.model.findIndex((obj) => obj.field == 'startTime')
        console.log(index)
        if (index !== -1) {
          this.$set(this.formFields.model[index].rules[1], 'required', false)
        }
      }

    },
    elDatePickerChange(e) {
      console.log(e)
      if (this.pageName == 'QianchuanScheduleTask') {
        let index = this.formFields.model.findIndex((obj) => obj.field == 'startTime')
        console.log(index)
        if (index !== -1) {
          this.$set(this.formFields.model[index].rules[1], 'required', true)
        }
      }
    },
    //更新模态框表单数据
    updateFormData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 处理金额类型
          let submitUpdateForm = {}
          if (this.updateForm) {
            for (let key in this.updateForm) {
              let updateFormField = this.updateFormFields.filter((item) => {
                return item.field === key
              })
              if (
                updateFormField &&
                updateFormField.length > 0 &&
                updateFormField[0]['type'] === 'money'
              ) {
                submitUpdateForm[key] = parseInt(
                  parseFloat((this.updateForm[key] * 100).toFixed(2)).toFixed(2)
                )
              } else {
                submitUpdateForm[key] = this.updateForm[key]
              }
            }
          }
          console.log('******update*******')
          if (this.pageName == 'QianchuanScheduleTask') {
            submitUpdateForm.status = 1
            submitUpdateForm.productTaskType = 1
            if (submitUpdateForm.enableBreakEvenRoiCheck) {
              submitUpdateForm.enableBreakEvenRoiCheck = 1
            } else {
              submitUpdateForm.enableBreakEvenRoiCheck = 0
            }
            if (submitUpdateForm.enableSuggestRoiThreshold) {
              submitUpdateForm.enableSuggestRoiThreshold = 1
            } else {
              submitUpdateForm.enableSuggestRoiThreshold = 0
            }
          } else if (this.pageName == 'QianchuanMultiProductScheduleTask') {
            submitUpdateForm.status = 1
            submitUpdateForm.productTaskType = 2
          }



          console.log(submitUpdateForm)
          this.$axios.post({
            url: this.url.update,
            data: submitUpdateForm,
            success: (res) => {
              if (res.code === 0) {
                this.$set(this.page, 'cursor', 0)
                console.log('updateFormData')
                this.getData()
                this.$message.success('修改信息成功')
                this.updateVisible = false
              } else {
                this.$message.error(res.msg ? res.msg : '修改信息失败')
              }
            },
            error: () => {
              this.$message.error('出错了')
            },
          })
        } else {
          return false
        }
      })
    },
    // 删除对应行
    deleteData(index) {
      this.tableData.splice(index, 1)
      console.log(this.tableData)
    },
    submitAll() {
      if (this.pageName == 'UniPromotionNew') {
        // 添加到全域计划
        console.log(this.tableData)
        let isReturn = false
        // let data = this.tableData[index]
        let list = []
        this.tableData.forEach((obj) => {
          if (isReturn) return
          if (obj.account) {
            if (!obj.account.id) {
              this.$message.error('存在账户未选择')
              isReturn = true
              return
            }
            this.$emit('data-loaded', {
              rows: this.tableData,
              page: { ...this.page },
              rawData: this.tableData,
            })
            this.syncTableLayout()
          } else {
            this.$message.error('存在账户未选择')
            isReturn = true
            return
          }
          if (obj.dyNumberList && obj.dyNumberList.length) {
            if (obj.selectedDYNumber) {
              if (!obj.selectedDYNumber.id) {
                this.$message.error('存在抖音号未选择')
                isReturn = true
                return
              }
            } else {
              this.$message.error('存在抖音号未选择')
              isReturn = true
              return
            }
          }

          if (obj.selectedList && obj.selectedList.length) {
            obj.selectedList.forEach((obj) => {
              obj.productname = obj.productName
              // obj.productId = JSON.parse(obj.productId)
            })
          } else {
            this.$message.error('存在商品组未添加')
            isReturn = true
            return
          }
          if (obj.AllBudget) {
            if (!obj.AllBudget.roiTarget || !obj.AllBudget.dayBudget) {
              this.$message.error('存在整体ROI目标/日预算未设置')
              isReturn = true
              return
            }
            if (obj.AllBudget.scheduleType === false) {
              if (!obj.AllBudget.startTime || !obj.AllBudget.endTime) {
                this.$message.error('存在投放时间未设置')
                isReturn = true
                return
              }
            }
          } else {
            this.$message.error('存在整体ROI目标/日预算未设置')
            isReturn = true
            return
          }

          const materialMode = obj.materialMode || 'AUTO'
          const selectedCreatives = Array.isArray(obj.selectedCreatives) ? obj.selectedCreatives : []
          if (materialMode === 'MANUAL') {
            const configuredIds = selectedCreatives.filter((item) => {
              return item && item.productId && item.selectedVideoId && item.selectedAwemeItemId && item.selectedTitle
            }).map((item) => String(item.productId))
            const hasMissingCreative = obj.selectedList.some((item) => configuredIds.indexOf(String(item.productId)) === -1)
            if (hasMissingCreative) {
              this.$message.error('存在自选素材未配置完成的商品')
              isReturn = true
              return
            }
          }

          let object = {
            agentId: 1,
            advertiserId: obj.account.id,
            aweMeId: obj.selectedDYNumber ? obj.selectedDYNumber.id : null,
            productList: obj.selectedList,
            roi: obj.AllBudget.roiTarget,
            budget: obj.AllBudget.dayBudget,
            img: obj.selectedList[0].img,
            deliveryMode: obj.deliveryMode || 'COST',
            materialMode: materialMode,
            selectedCreatives: selectedCreatives,
            scheduleType: obj.AllBudget.scheduleType !== false,
            startTime: obj.AllBudget.scheduleType === false ? obj.AllBudget.startTime : null,
            endTime: obj.AllBudget.scheduleType === false ? obj.AllBudget.endTime : null
          }
          list.push(object)
        })
        console.log(list, 'list')
        if (isReturn) return
        this.$axios.post({
          url: '/launchTheProduct/add/list',
          data: {
            launchTheProductRequestVoList: list
          },
          success: (res) => {
            console.log(res)
            if (res.code === 0) {
              this.$message.success('添加成功')
              this.tableData = [{}]
            } else {

              console.log(res.data)
              const indexArr = res.data['成功索引']
              console.log(indexArr)
              indexArr.slice().sort((a, b) => b - a).forEach(index => {
                if (index < this.tableData.length) {
                  this.tableData.splice(index, 1);
                }
              });
              console.log(this.tableData)
              let reasonArr = res.data['失败列表']
              let productArr = res.data['异常商品']
              productArr.forEach((obj) => {
                let index = this.tableData.findIndex((object) => {
                  if (object.selectedDYNumber && object.selectedDYNumber.id) {
                    return object.selectedDYNumber.id == obj.aweMeId && object.account.id == obj.advertiserId
                  } else {
                    return object.account.id == obj.advertiserId
                  }
                })
                console.log(index, '1111')
                if (index !== -1) {
                  let arr = this.tableData[index].selectedList.filter((object) => {
                    return String(object.productId) !== String(obj.productId)
                  })
                  this.$set(this.tableData[index], 'selectedList', arr)
                  if (Array.isArray(this.tableData[index].selectedCreatives)) {
                    let selectedCreatives = this.tableData[index].selectedCreatives.filter((object) => {
                      return String(object.productId) !== String(obj.productId)
                    })
                    this.$set(this.tableData[index], 'selectedCreatives', selectedCreatives)
                  }
                  console.log(this.tableData[index], '2222')
                }
              })
              reasonArr.forEach((obj) => {
                setTimeout(() => {
                  this.$message.error('抖音号' + obj['抖音账号ID'] + obj['异常原因'])
                }, 100)
              })
              if (!reasonArr.length) {
                this.$message.error(res.msg || '添加失败')
              }

            }
          },
          error: () => {
            this.$message.error('出错了')
          },
        })

      } else {
        if (!this.tableData.length) {
          this.$message.error('请至少配置一项佣金率')
          return
        }
        let isEmpty = false
        this.tableData.forEach((obj) => {
          console.log(obj)
          if (obj.minCommission === '' || obj.maxCommission === '' || obj.targetRoi === '') {
            isEmpty = true
            return
          }
        })
        if (isEmpty) {
          this.$message.error('佣金率配置不能为空')
          return
        }
        this.$message.success('佣金率配置保存成功')

      }


    },

    checkCommission() {
      this.tableData.forEach((obj, index) => {
        if (this.tableData[index - 1] && this.tableData[index - 1].maxCommission && obj.minCommission) {
          if (JSON.parse(obj.minCommission) <= JSON.parse(this.tableData[index - 1].maxCommission)) {
            this.$set(obj, 'minCommission', (JSON.parse(this.tableData[index - 1].maxCommission) + 0.01).toFixed(2))
          }
        }
        if (!obj.maxCommission || !obj.minCommission) return
        if (JSON.parse(obj.maxCommission) <= JSON.parse(obj.minCommission)) {
          this.$set(obj, 'maxCommission', (JSON.parse(obj.minCommission) + 0.01).toFixed(2))
        }

      })
    },

    //  修改全域计划
    submitEdit() {
      let isReturn = false
      if (this.tableData[0].selectedList && this.tableData[0].selectedList.length) {
        this.tableData[0].selectedList.forEach((obj) => {
          obj.productname = obj.productName
          obj.img = obj.img || obj.productImage
        })
      } else {
        this.$message.error('存在商品组未添加')
        isReturn = true
        return
      }
      if (this.tableData[0].AllBudget) {
        if (!this.tableData[0].AllBudget.roiTarget) {
          this.$message.error('存在整体ROI目标/日预算未设置')
          isReturn = true
          return
        }
      } else {
        this.$message.error('存在整体ROI目标/日预算未设置')
        isReturn = true
        return
      }
      if (isReturn) return

      console.log(this.tableData, this.route_params, '5566')
      let arr1 = []
      let arr2 = []
      this.tableData[0].editList.forEach((obj) => {
        arr1.push(obj.productId)
      })
      this.tableData[0].selectedList.forEach((obj) => {
        arr2.push(obj.productId)
      })
      let isDelete = arr2.every(item => arr1.includes(item))
      let isEditBudgetOnly = arr2.every(item => arr1.includes(item)) && arr2.length == arr1.length
      if (this.tableData[0].beforeEditAllBudget.dayBudget !== this.tableData[0].AllBudget.dayBudget || this.tableData[0].beforeEditAllBudget.roiTarget !== this.tableData[0].AllBudget.roiTarget) {
        isDelete = false
      }

      if (isDelete) {
        if (this.tableData[0].editList.length == this.tableData[0].selectedList.length) {
          this.$message.error('请进行修改')
          return
        }
        let productIds = []
        this.tableData[0].editList.forEach((obj) => {
          if (!arr2.includes(obj.productId)) {
            productIds.push(obj.productId)
          }
        })
        let data = {
          advertiserId: this.tableData[0].account.id,
          adId: [this.tableData[0].adId],
          productIds
        }
        console.log(data)
        this.$axios.post({
          url: '/uniPromotion/product/delete',
          data,
          success: (res) => {
            console.log(res)
            if (res.code === 0) {
              this.$message.success('编辑成功')
              this.$router.push({
                path: '/qdd/admin/uniPromotion.html',
                query: {
                  isRefreshData: true,
                }
              })
            } else {
              this.$message.error(res.msg || '编辑失败')
            }
          },
          error: () => {
            this.$message.error('出错了')
          },
        })
      } else {
        let data
        if (isEditBudgetOnly) {
          data = {
            advertiserId: this.tableData[0].account.id,
            // aweMeId: this.tableData[0].selectedDYNumber ? this.tableData[0].selectedDYNumber.id : null,
            adId: this.tableData[0].adId,
            budget: this.tableData[0].beforeEditAllBudget.dayBudget == this.tableData[0].AllBudget.dayBudget ? null : this.tableData[0].AllBudget.dayBudget,
            roi: this.tableData[0].beforeEditAllBudget.roiTarget == this.tableData[0].AllBudget.roiTarget ? null : this.tableData[0].AllBudget.roiTarget,
          }
        } else {
          data = {
            advertiserId: this.tableData[0].account.id,
            aweMeId: this.tableData[0].selectedDYNumber ? this.tableData[0].selectedDYNumber.id : null,
            adId: this.tableData[0].adId,
            adName: this.tableData[0].planName,
            budget: this.tableData[0].AllBudget.dayBudget,
            roi: this.tableData[0].AllBudget.roiTarget,
            productList: this.tableData[0].selectedList,
            scheduleType: true
          }
        }
        console.log(data)
        this.$axios.post({
          url: '/launchTheProduct/updateAd',
          data,
          success: (res) => {
            console.log(res)
            if (res.code === 0) {
              this.$message.success('编辑成功')
              this.$router.push({
                path: '/qdd/admin/uniPromotion.html',
                query: {
                  isRefreshData: true,
                }
              })
            } else {
              this.$message.error(res.msg || '编辑失败')
            }
          },
          error: () => {
            this.$message.error('出错了')
          },
        })
      }

    },

    //单个删除
    deleteRole(row) {
      this.$axios.post({
        url: this.url.delete + '/' + row.id,
        success: (res) => {
          if (res.code === 0) {
            this.$message.success('删除成功')
            //如果当前页只有一条记录  当前页数减 1
            if (this.page.realSize === 1) {
              this.page.current = this.page.current - 1
            }
            this.$set(this.page, 'cursor', 0)
            console.log('deleteRole')
            this.getData()
          } else {
            this.$message.error(res.msg || '删除失败')
          }
        },
        error: () => {
          this.$message.error('出错了')
        },
      })
    },
    // 切换投放方式
    changeActiveType(type) {
      this.activeType = type
      console.log('changeActiveType')
      this.changePageIndexTogetDate()
    },
    confirmToChange() {
      console.log('confirmToChange')
      this.showFilterPopup = false
      this.changePageIndexTogetDate()
    },

    pickData(e, isLimit) {
      console.log('pickData', e, isLimit)
      if (e) {
        if (isLimit) {
          if (this.pageName === 'UniPromotion') {
            if (!this.isUniPromotionDateRangeWithinLimit(e)) {
              this.$message.warning(`最多只能查询最近 ${this.maxUniPromotionSelectableDays} 天的数据`)
              if (this.lastValidUniPromotionSelectData && this.lastValidUniPromotionSelectData.length === 2) {
                this.selectData = this.cloneUniPromotionDateRange(this.lastValidUniPromotionSelectData)
              } else {
                this.selectData = []
              }
              return
            }
            this.lastValidUniPromotionSelectData = this.cloneUniPromotionDateRange(e)
          } else
          if (e && e.length === 2) {
            const startDate = e[0];
            const endDate = e[1];

            // 计算两个日期之间的毫秒差
            const timeDiff = endDate.getTime() - startDate.getTime();
            // 转换为天数（除以每天的毫秒数）
            const dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

            // 检查是否超过180天
            if (dayDiff > 180) {
              // 弹出错误提示
              this.$message.error('选择的日期范围不能超过180天，请重新选择');
              // 重置选择
              this.selectData = [];
              return
            }
          }
        }
        console.log(e, '233')
        console.log(this.selectData, '233')
        const year_start = e[0].getFullYear()
        const month_start = String(e[0].getMonth() + 1).padStart(2, '0')
        const day_start = String(e[0].getDate()).padStart(2, '0')
        this.selectStartData = `${year_start}-${month_start}-${day_start}`
        // const year_end = e[0].getFullYear()
        // const month_start = String(e[0].getMonth() + 1).padStart(2, '0')
        // const day_start = String(e[0].getDate()).padStart(2, '0')
        const inputDate = new Date(e[1])
        this.selectEndData = this.processDate(inputDate);
        console.log(this.selectStartData, this.selectEndData, '233')
      } else {
        if (this.pageName === 'UniPromotion') {
          this.lastValidUniPromotionSelectData = null
        }
        this.selectStartData = ''
        this.selectEndData = ''
      }
    },
    cloneUniPromotionDateRange(range) {
      if (!Array.isArray(range) || range.length !== 2 || !range[0] || !range[1]) {
        return null
      }
      return [new Date(range[0]), new Date(range[1])]
    },
    isUniPromotionDateRangeWithinLimit(range) {
      if (!Array.isArray(range) || range.length !== 2 || !range[0] || !range[1]) {
        return false
      }
      const startDate = new Date(range[0])
      const endDate = new Date(range[1])
      const earliest = new Date()
      earliest.setHours(0, 0, 0, 0)
      earliest.setDate(earliest.getDate() - (this.maxUniPromotionSelectableDays - 1))
      const today = new Date()
      today.setHours(23, 59, 59, 999)
      return startDate.getTime() >= earliest.getTime() &&
        endDate.getTime() <= today.getTime() &&
        startDate.getTime() <= endDate.getTime()
    },
    processDate(targetDate) {
      const now = new Date();
      // 创建目标日期的纯日期部分（去除时间）
      const targetDateOnly = new Date(
        targetDate.getFullYear(),
        targetDate.getMonth(),
        targetDate.getDate()
      );

      // 创建当前日期的纯日期部分（去除时间）
      const todayOnly = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate()
      );

      console.log(targetDateOnly.getTime() === todayOnly.getTime(), now, '555555')
      if (targetDateOnly.getTime() === todayOnly.getTime()) {
        // 如果是今天：返回当前完整时间（年月日时分秒）

        const year = now.getFullYear()
        const month = String(now.getMonth() + 1).padStart(2, '0')
        const day = String(now.getDate()).padStart(2, '0')
        // const hours = String(now.getHours()).padStart(2, '0')
        // const minutes = String(now.getMinutes()).padStart(2, '0')
        // const seconds = String(now.getSeconds()).padStart(2, '0')
        return `${year}-${month}-${day}`
      } else {
        const year_end = targetDate.getFullYear()
        const month_end = String(targetDate.getMonth() + 1).padStart(2, '0')
        const day_end = String(targetDate.getDate()).padStart(2, '0')
        return `${year_end}-${month_end}-${day_end}`
      }
    },
    changeConsumeInfo(e) {
      console.log(e)
    },
    //批量删除
    delete_batch() {
      if (this.pageName == 'UniPromotion') {
        if (Number(this.advertiserId) <= 0) {
          this.$message.warning('全部视图仅支持查询，请先切换到具体店铺后再执行批量删除')
          return
        }
        if (this.selectadIds.length <= 0) {
          this.$message.warning('请选中要删除的数据')
          return
        }
        let adIds = []
        this.selectadIds.forEach((obj) => {
          if (obj.status !== 'DELETE') {
            adIds.push(obj.adId)
          }
        })
        let data = { adId: adIds, optStatus: 2, advertiserId: this.advertiserId }
        console.log(data, 'data=====', this.selectadIds)
        this.$axios.post({
          url: '/uniPromotion/updateAdStatus',
          data,
          confirm: '确定删除选中的全域计划？',
          success: (data) => {
            if (data.code == 0) {
              console.log('delete_batch')
              this.getData()
              this.$message.success('删除成功')
            } else {
              this.$message.error(data.msg || '出错了')
            }
          }
        });
        return
      }
      if (this.selectedIds.length <= 0) {
        this.$message.warning('请选中要删除的数据')
        return
      }

      this.$axios.post({
        url: this.url.delete_batch,
        data: { ids: this.selectedIds.join(",") },
        confirm: '此操作将删除选中的数据, 是否继续?',
        success: (res) => {
          if (res.code === 0) {
            this.$set(this.page, 'cursor', 0)
            console.log('delete_batch')
            this.getData()
            this.$message.success('删除成功')
          } else {
            this.$message.error('删除失败')
          }
        },
        error: () => {
          this.$message.error('出错了')
        },
      })
    },

    //改变当前显示条数
    sizeChange(val) {
      this.page.size = val
      this.$set(this.page, 'cursor', 0)
      console.log('sizeChange')
      this.getData()
    },
    //改变当前页
    currentChange(val) {
      this.page.current = val
      this.$set(this.page, 'cursor', 0)
      console.log('currentChange')
      this.getData()
    },
    //复选框选中
    handleSelectionChange(data) {
      console.log(data)
      console.log("545")
      this.selectedIds = []
      this.selectProductIds = []
      this.selectadIds = []
      for (let i = 0; i < data.length; i++) {
        this.selectedIds.push(data[i].id)
        if (data[i].productId) {
          this.selectProductIds.push(data[i].productId)
        }
        if (data[i].adId) {
          this.selectadIds.push(data[i])
        }
      }
      this.$emit('returnId', this.selectedIds)
      this.$emit('returnProductId', this.selectProductIds)
      this.$emit('returnADId', this.selectadIds)
    },

    //改变状态
    statusChange(row, item) {
      let data = { id: row.id }
      data[item.field] = row[item.field]
      console.log(data, row, item)
      if (this.pageName == 'ShutDownDueToOverallLosses' || this.pageName == 'intelligentRegulation' || this.pageName == 'BalanceManage' || this.pageName == 'BudgetManage' || this.pageName == 'intelligentAutoRebuildManage') {
        // let index = this.tableData.findIndex((obj) => obj.id == data.id)
        // this.$set(this.tableData[index], 'status', false)
        // console.log(index)
        let postData = row
        if (this.pageName == 'ShutDownDueToOverallLosses') {
          postData.intelligentRegulationType = 0
        } else if (this.pageName == 'intelligentRegulation') {
          postData.intelligentRegulationType = 1
        } else if (this.pageName == 'BalanceManage') {
          postData.intelligentRegulationType = 2
        } else if (this.pageName == 'BudgetManage') {
          postData.intelligentRegulationType = 3
        } else if (this.pageName == 'intelligentAutoRebuildManage') {
          postData.intelligentRegulationType = 4
        }
        // console.log(postData.status)
        postData.status = postData.status ? 1 : 0
        console.log(postData, 'postData')
        this.$axios.post({
          url: 'smartRoiRules/update',
          data: postData,
          success: (res) => {
            // this.loading = false
            console.log('333', res)
            if (res.code == 0) {
              // this.showAddCreateRulePopup = false
              console.log('statusChange')
              this.getData()
            } else {
              // this.$message.error(res.msg || '出错了')

            }
          },
          error: () => {
            this.loading = false
            this.$message.error('出错了')
          },
        })
      } else {
        this.$axios.post({
          url: this.url.status,
          data: data,
          success: (res) => {
            if (res.code === 0) {
              if (row.status === 1) {
                this.$message.success('操作成功')
                return
              }
              this.$message.success('操作成功')
            } else {
              if (row.status === 1) {
                this.$message.error('操作失败')
              } else {
                this.$message.error('操作失败')
              }
              this.$set(this.page, 'cursor', 0)
              console.log('statusChange')
              this.getData()
            }
          },
          unauthorized: () => {
            this.$set(this.page, 'cursor', 0)
            console.log('statusChange')
            this.getData()
          },
          error: () => {
            this.$set(this.page, 'cursor', 0)
            console.log('statusChange')
            this.getData()
            this.$message.error('出错了')
          },
        })

      }
    },
    moreStatusChange(row, item, it) {
      let data = {}
      // 如果存在url,则进行自定义状态修改
      if (item.show.url) {
        data = JSON.parse(JSON.stringify(row))
      } else {
        // 否则为纯状态修改
        data[this.key] = row[this.key]
      }
      data[item.field] = it.key
      let nowValue = ''
      item.values.some((val) => {
        if (val.key === row[item.field]) {
          nowValue = val.value
          return true
        }
      })
      this.$axios.post({
        url: item.show.url ? item.show.url : this.url.status,
        confirm: it.confirm
          ? it.confirm(row[item.confirm])
          : '是否将' +
          (row[item.confirm]
            ? ' ' + row[item.confirm] + ' 的' + item.label + '从' + nowValue
            : '该状态') +
          '更改为' +
          it.value +
          '?',
        data: data,
        success: (res) => {
          if (res.code === 0) {
            this.$message.success('修改成功')
            row[item.field] = it.key
            return
          }
          this.$message.error(res.msg ? res.msg : '修改失败')
        },
      })
    },

    //重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },

    // 设置权限
    setPermission(perm) {
      this.addPermission = perm.add
      this.updatePermission = perm.update
      this.deletePermission = perm.delete
      this.deleteBatchPermission = perm.deleteBatch
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.page, 'current', 1)
      this.$set(this.page, 'cursor', 0)
      this.pageIndex = 1
      console.log('handleSearch')
      this.getData()
    },
    resetSearchConditions() {
      if (this.searchs && this.searchs.length) {
        this.searchs.forEach((search) => {
          this.$set(this.query, search.name, search.type === 'selectAccount' ? [] : '')
        })
      } else {
        this.query = {}
      }
      this.selectData = []
      this.order = null
      this.sort = null
      this.$set(this.page, 'current', 1)
      this.$set(this.page, 'cursor', 0)
      this.pageIndex = 1
      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      this.selectedIds = []
      this.selectProductIds = []
      this.selectadIds = []
      this.$emit('table-reset')
      this.getData()
    },
    handleAdd() {
      this.$emit('addCreateRule')
    },
    // 上传图片前的格式检查
    beforeUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG 或是 PNG 格式!')
        return false
      }
      if (!isLt10M) {
        this.$message.error('上传头像图片大小不能超过 10MB!')
        return false
      }
      return true
    },
  },
}
</script>

<style scoped>
.greenDot {
  background-color: #0da600;
  height: 6px;
  width: 6px;
  border-radius: 50%;
  margin-right: 3px;
}

.protectActive {
  height: 20px;
  line-height: 20px;
  cursor: pointer;
  font-size: 13px;
  border: 1px solid #00943e33;
  border-radius: 5px;
  padding: 0 3px;
  color: #0da600;
  background-color: #ecf8eb;


}

.c_409EFF {
  color: #409EFF;
}


.authorizeBox .el-button {
  font-size: 12px;
  /* width: 80px; */
  padding: 0 17px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}


.monitorListBox {
  max-height: 80px;
  overflow: scroll;
}

.line {
  vertical-align: middle;
  background: #dedede;
  width: 1px;
  height: 28px;
  margin: 0 10px 0 0;
  display: inline-block;
}

.willPublic {
  background-color: rgb(255, 167, 215) !important;
  border-color: rgb(255, 167, 215) !important;
}

.noVideoColor {
  color: grey !important;
}

.table-container {
  min-height: 100%;
  width: 100%;
  min-width: 0;
}

.table-body {
  padding: 14px 16px 12px;
  border-radius: 12px;
  border: 1px solid #e8eef6;
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(31, 42, 68, 0.05);
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.common-table-slot-content {
  min-height: 220px;
  min-width: 0;
}

.table-alert-inline {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  white-space: nowrap;
}

.table-tools {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px 0;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #eef3fb;
}

.table-tools .el-button {
  margin-right: 10px;
  margin-left: 0;
}

.pagination {
  margin-top: 1rem;
}

.el-table>>>thead tr th {
  background-color: #f7faff;
  color: #41536d;
  font-weight: 600;
}

.el-table>>>td,
.el-table>>>th {
  padding: 10px 0;
}

.el-table>>>tbody tr:hover > td {
  background-color: #f9fbff !important;
}

.el-table>>>.el-table__empty-block {
  min-height: 180px;
}

.el-table>>>.image-column .cell {
  line-height: 13px;
}


.mr10 {
  margin-right: 10px;
}

.table-expand {
  font-size: 0;
}

.table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  margin-left: 10px;
  width: 40%;
}

.table-expand label {
  width: 90px;
  color: #99a9bf;
}

.table-expand>>>.el-form-item__content span {
  word-break: break-all;
  white-space: pre-wrap;
}

.field-tip {
  margin-top: 6px;
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid #e8edf5;
  background: #f6f9fc;
  line-height: 1.55;
  font-size: 12px;
  color: #5f6f86;
}

.form-guide-panel {
  margin-bottom: 12px;
}

.field-guide-panel {
  margin-top: 8px;
}

.table-body>>>.cell-no-center {
  text-align: left;
}

.table-body>>>.cell-center {
  text-align: center;
}

.status-menu {
  padding: 5px 0;
}

.status-menu>>>.el-dropdown-menu__item {
  font-size: 13px;
  line-height: 27px;
  color: cadetblue;
  font-weight: 600;
}

.dialog_body {
  padding: 12px 20px 4px;
  background: #ffffff;
  box-sizing: border-box;
}

.dialog-footer {
  padding: 10px 20px 14px;
  border-top: 1px solid #eef3fb;
  background: #fbfcff;
}

.dialog-footer .el-button {
  min-width: 88px;
  border-radius: 9px;
}

/deep/ .common-dialog {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 12px 32px rgba(31, 42, 68, 0.12);
}

/deep/ .common-dialog .el-dialog__header {
  padding: 14px 20px;
  border-bottom: 1px solid #eef3fb;
  background: linear-gradient(180deg, #fbfdff 0%, #f5f9ff 100%);
}

/deep/ .common-dialog .el-dialog__body {
  padding: 0;
}

/deep/ .common-dialog .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2a44;
}

/deep/ .common-dialog .el-dialog__headerbtn {
  top: 14px;
  right: 16px;
}

/deep/ .common-table-form {
  padding: 0 2px;
}

/deep/ .common-table-form .el-form-item {
  margin-bottom: 14px;
}

/deep/ .common-table-form .el-form-item__label {
  color: #2d3c53;
  font-weight: 600;
}

/deep/ .common-table-form .el-input__inner,
/deep/ .common-table-form .el-textarea__inner,
/deep/ .common-table-form .el-select .el-input__inner {
  border-radius: 8px;
  border-color: #d9e4f5;
  box-shadow: none;
}

/deep/ .common-table-form .el-form-item__content {
  line-height: 1.4;
}

/deep/ .common-table-form .el-input__inner:focus,
/deep/ .common-table-form .el-textarea__inner:focus {
  border-color: #5d8dff;
  box-shadow: 0 0 0 3px rgba(93, 141, 255, 0.12);
}

/deep/ .common-table-form .el-textarea__inner {
  line-height: 1.7;
}

::v-deep .el-dropdown [disabled] {
  cursor: inherit;
}

.loadingMoreBox {
  padding: 20px 0;
  position: relative;
  text-align: center;
  color: #5d6979;
  cursor: pointer;
}

.totalBox {
  position: absolute;
  top: 20px;
  left: 20px;
  font-size: 14px;
}

/* account */
.account_box,
.account_box2 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  padding: 7px 12px;
  cursor: pointer;
  height: 73px;

}

.account_box3 {
  height: 40px;
  padding: 10px 12px;
  /* justify-content: flex-start; */
  color: #a2a2a2;

}

.account_box4 {
  cursor: not-allowed !important;
  background-color: #f5f5f5 !important;
  color: #a2a2a2 !important;
}

.select_account_box {
  justify-content: flex-start;
}

.account_box:hover {
  border: 1px solid #346bf6;
}

.account_box2:hover {
  background-color: #ecf3fe;
}

.accountNameBox {
  display: flex;
  align-items: center;
}

.accountNameBox img {
  height: 25px;
  width: 25px;
  border-radius: 50%;
}

.accountNameBox i {
  padding-top: 1.8px;
}

.accountNameBox .name {
  padding-left: 5px;
}

.idBox {
  display: flex;
  padding-top: 10px;
  color: #999;
  font-size: 14px;
}


.account_shop_box,
.account_shop_box2 {
  color: #346bf6;
  width: 35px;
  background: #4389f91a;
  border-radius: 3px;
}

.account_shop_box {
  position: absolute;
  top: 7px;
  right: 35px;
}

.account_normal_box {
  color: #0adc7d;
  background: #0adc7d1a;
  padding: 3px;
  border-radius: 3px;
}

.account_selector_popup_box {
  z-index: 100;
  padding: 20px;
  position: absolute;
  top: 73px;
  left: 0;
  background-color: #fff;
  box-shadow: 0 0 10px #c7c6c6;
}

.noSelect {
  top: 40px;
}

.account_selector_popup_box2 {
  min-width: 280px;
  top: 0;
  left: 0;
}

.account_selector_popup_box3 {
  width: 600px;
}

/deep/ .account_selector_popup_box .no-input .el-input__inner {
  border-color: #ff3939 !important;
}

.select_account_all_box {
  padding-top: 20px;
  max-height: 300px;
  overflow: scroll;
}

.account_right_box2 {
  display: flex;
  flex-direction: column;
  align-items: end;
}

.selectBtn {
  cursor: pointer;
  border: 1px solid #C0C4CC;
  padding: 0 7px;
  height: 30px;
  line-height: 30px;
  border-radius: 5px;
}


/* dyNumber */

.choose_box {
  cursor: pointer;
  margin-left: 30px;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  overflow: hidden;
}

.choose_box div {
  padding: 6px 15px;
}

.choosed_box {
  background-color: #346bf6;
  color: #fff;
}

/* 商品组 */
.add_product_box,
.add_product_box2 {
  cursor: pointer;
  border: 1px dashed #ddd;
  background-color: #fff;
  box-shadow: 0 0 4px #00000014;
  height: 70px;
  overflow: hidden;
}

.add_product_box {
  line-height: 70px;
  color: #999999;
}

.add_product_box2 {
  font-size: 15px;
  height: 80px;
  border: 1px solid #ddd;
  box-shadow: 0 0 4px #00000014;
  border-radius: 5px;
}

.product_text_box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

}

.add_product_box2 img {
  height: 80px;
  width: 80px;
}

/* 整体ROI目标/日预算 */
.add_target_box i {
  color: #346bf6;
  cursor: pointer;
}

.yuan_box {
  position: absolute;
  top: 10px;
  right: 15px;
}

/* 抖音号信息 */
.avtImg {
  height: 80px;
  width: 80px;
  border-radius: 5px;
}

/* 商品信息 */
.scroll_box {
  overflow: scroll;
  max-height: 300px;
}

.hoverProductBox {
  background-color: #edf4ff;
  border-radius: 3px;
}

.hoverProductBox img {
  height: 70px;
  width: 70px;
}

.goods_box {
  cursor: pointer;
  background-color: #f4f4f5;
  width: 80px;
  height: 80px;
  border-radius: 5px;
  flex-wrap: wrap;
}

.goods_box img {
  height: 32px;
  width: 32px;
  border-radius: 5px;
}

/* 投放方式 */

.smart_bid_type_box div {
  /* box-sizing: border-box; */
  font-size: 14px;
  height: 30px;
  width: 100px;
  color: #666;
  cursor: pointer;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 0 5px 5px 0;
}

.smart_bid_type_box div:first-child {
  border-radius: 5px 0 0 5px;
}

.smart_bid_type_box .activeType {
  z-index: 1;
  color: #409EFF;
  background: #fff;
  border-color: #409EFF;
}

.filter_box {
  font-size: 14px;
  cursor: pointer;
  width: 180px;
  height: 30px;
  border: 1px solid #409EFF;
  border-radius: 5px;
}

.searchPlanBox {
  flex-grow: 1;
  justify-content: flex-end;
  padding-right: 20px;
  box-sizing: border-box;
  /* padding-left: 70%; */
}

.search_icon_box {
  cursor: pointer;
  border-radius: 0 30px 30px 0;
  background-color: #409EFF;
  height: 30px;
  width: 40px;
  margin-bottom: 10px;
  box-sizing: border-box;
}

.search_icon_box i {
  color: #fff;
}


/* 新增创建规则 */
.addCreateRuleBox {
  background-color: red;

}

/* 账户报表 */

.selectAccountBox {
  border: 1px solid #DCDFE6;
  width: 250px;
  padding: 0 5px;
  border-radius: 3px;
  height: 30px;
  box-sizing: border-box;
  color: #666;
}

.selectAccountBox i {
  color: #a2a2a2;

}

/deep/.el-input__icon,
/deep/.el-range-separator {
  display: flex;
  align-items: center;
  justify-content: center;
}

/*  */
/deep/.searchPlanBox .el-input__inner {
  height: 30px !important;
  width: 90px !important;
  border-radius: 0px;
}



/deep/.overIsVisible .el-table .cell {
  overflow: visible;
}

/deep/.overIsVisible .no-label .el-radio__label {
  display: none !important;
}

/deep/.overIsVisible .setChooseBox .el-radio {
  margin-right: 10px !important;
}

/deep/.overIsVisible .el-table__body {
  overflow: visible !important;
}

/deep/.overIsVisible .el-table {
  overflow: visible !important;
}

/deep/.overIsVisible .el-table__body-wrapper {
  overflow: visible !important;
}

/deep/.overIsVisible .el-table__row {
  overflow: visible !important;
}




/deep/ .responsiveInput .el-input__inner {
  height: 30px !important;
  width: 120px !important;
  font-size: 12px !important;
}

/deep/ .responsiveInput .el-input__suffix {
  display: flex;
  justify-content: center;
  align-items: center;
}

/deep/ .el-pagination__total {
  font-size: 12px !important;
}

.responsiveInput2 {
  font-size: 13px;
  width: 180px !important;
}


.responsiveInput4 {
  width: 220px !important;
}

.uni-promotion-actions-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 22px;
}

.uni-promotion-actions-column .c_346bf6 {
  cursor: pointer;
  text-align: center;
}

/deep/.responsiveInput2 .el-input__inner {
  height: 30px !important;
  width: 180px !important;
  border-radius: 0px;

}


.responsiveInput3 {
  font-size: 12px;
  width: 150px !important;
}


/deep/.responsiveInput3 .el-input__inner {
  height: 30px !important;
  width: 150px !important;
  border-radius: 0px;

}

/deep/.notExist {
  margin-bottom: 0px !important;
}

@media (max-width: 768px) {
  el-table {
    /* height: 60vh !important; */
    max-width: 500px;
    font-size: 10px !important;
    overflow: scroll;
  }

  /deep/ .el-pagination__total {
    padding-bottom: 40px !important;
    display: block !important;
  }

  .table-body {
    padding-bottom: 15px;
  }

  /deep/ .el-pagination__jump {
    margin-left: 0 !important;
  }

  /deep/ .el-pagination__editor.el-input {
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .authorizeBox {
    flex-grow: inherit;
    justify-content: flex-start;
  }

  .smart_bid_type_box div {
    width: 80px;
  }

  .filter_box {
    width: 130px;
  }

  .account_selector_popup_box3 {
    padding: 10px !important;
    width: 280px;
  }

  .searchPlanBox {
    justify-content: flex-start;
  }


  /deep/.overIsVisible .el-table {
    overflow: scroll !important;
  }

  /deep/.overIsVisible .el-table .cell {
    overflow: visible;
  }



  /deep/.overIsVisible .el-table__body {
    overflow: scroll !important;
  }


  /deep/.overIsVisible .el-table__body-wrapper {
    overflow: scroll !important;
  }

  /deep/.overIsVisible .el-table__row {
    overflow: visible !important;
  }

  .account_box,
  .account_box2 {
    width: 250px;
  }

  .select_account_all_box {
    max-height: 180px;
  }

  .hoverProductBox img {
    height: 50px;
    width: 50px;
  }


}
</style>
